import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ChangeDetectionStrategy,
  inject,
  output
} from "@angular/core";
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, FormControlName, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ModalController, IonButton, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonModal, IonNote, IonRadio, IonRadioGroup, IonRow, IonSearchbar, IonSelect, IonSelectOption, IonTabBar, IonTabButton, IonTabs, IonText, IonThumbnail, IonTitle, IonToolbar } from "@ionic/angular";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import {
  GroupedComponents,
  SmartComponentKind,
} from "src/components/shared-components/class/smart-components/smart-component-kind";
import { SmartComponentNewPropertySave } from "src/components/shared-components/class/smart-components/smart-component-new-property-save";
import { SmartComponentProperty } from "src/components/shared-components/class/smart-components/smart-component-property";
import { Environment } from "../../class/general-classes/environment";
import { SmartComponent } from "../../class/smart-components/smart-component";
import { SmartComponentEnvironmentAssociated } from "../../class/smart-components/smart-component-environment-associated";
import { Skill } from "../../class/smart-components/smart-component-skill";
import { SmartComponentPropertySave } from "../../class/smart-components/smart-componment-property-save";

import { EnvironmentCategory } from "src/components/shared-components/enum/enumEnvironment";
import { ApplicationTheme } from "src/components/shared-components/enum/enumMisc";
import { AlertService } from "src/service/alert.service";
import { LoaderService } from "src/service/loader.service";
import { SmartComponentService } from "../../service/smart-component.service";
import { ThemeService } from "src/service/theme.service";
import { StaticClass } from "../../class/general-classes/static-classes";
import { CounterType } from "../../enum/enumCounterType";
import { SkillFormat } from "../../enum/enumSkillFormat";
import { SkillNameList } from "../../enum/enumSkillNameList";
import { SmartComponentType } from "../../enum/enumSmartComponentType";
import { SmartComponentTypeKind } from "../../enum/enumSmartComponentTypeKind";
import { SelectionAddressOrAddressFunction } from "../../enum/enumAddress";
import { AddSmartComponentComponent } from "../add-smart-component/add-smart-component.component";
import { ViewMode } from "../../enum/enumViewMode";
import { SearchAddressComponent } from "../general-components/search-address/search-address.component";
import { SmartComponentPropertyDetails } from "../../class/smart-components/smart-component-property-details";
import { AddressService } from "src/service/address.service";
import { AssociationSmartComponent } from "../../interfaces/association-smart-component";
import { IconHelper } from "../../class/icon-helper";
import { PopupSearchSelectComponent } from "src/components/shared-components/components/general-components/popup-search-select/popup-search-select";
import { PopupKeywordComponent } from "src/components/shared-components/components/general-components/popup-keyword/popup-keyword";
import { AppSettings } from "../../class/general-classes/app-settings";
import { PopupRepositoryIconComponent } from "../general-components/popup-repository-icon/popup-repository-icon.component";
import { ScenariosService } from "src/service/scenarios.service";
import { Scenario } from "src/components/shared-components/class/general-classes/scenario";
import { environment } from "src/environments/environment";
import { HideDataService } from "src/components/shared-components/service/hide-data.service";
import { ImagePosition } from "../../enum/enumImagePosition";
import { EnvironmentService } from "src/service/environment.service";
import { MdSelectDirective } from "../../../../directive/md-select.directive";
import { PlatformModeContentDirective } from "../../../../directive/platform-mode-content.directive";
import { KeyValuePipe } from "@angular/common";
import { SmartComponentRenderingDirectiveDirective } from "../../directives/smart-component-rendering-directive.directive";

@Component({
    selector: "app-configuration-smart-component",
    templateUrl: "./configuration-smart-component.component.html",
    styleUrls: ["./configuration-smart-component.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonButton, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonModal, IonNote, IonRadio, IonRadioGroup, IonRow, IonSearchbar, IonSelect, IonSelectOption, IonTabBar, IonTabButton, IonTabs, IonText, IonThumbnail, IonTitle, IonToolbar, FormsModule, MdSelectDirective, PlatformModeContentDirective, ReactiveFormsModule, SmartComponentRenderingDirectiveDirective, KeyValuePipe, TranslatePipe]
})
export class ConfigurationSmartComponentComponent
  implements OnInit, OnDestroy {
  private readonly _translateService = inject(TranslateService);
  private readonly _themeService = inject(ThemeService);
  private readonly fb = inject(UntypedFormBuilder);
  private readonly _modalCtrl = inject(ModalController);
  private readonly _alertService = inject(AlertService);
  private readonly _smartComponentService = inject(SmartComponentService);
  private readonly _loaderService = inject(LoaderService);
  private readonly _addressService = inject(AddressService);
  private readonly _modalController = inject(ModalController);
  private readonly _hideDataService = inject(HideDataService);
  private readonly _scenariosService = inject(ScenariosService);
  private readonly _environmentService = inject(EnvironmentService);

  private _formSubscription: Subscription;
  private _environmentDataSubscription: Subscription = null;
  private _scenarioSubscription: Subscription = null;

  //Updated list of scenarios shown in the scenario search-select popup
  private _listScenario: Scenario[] = [];
  private _idSmartComponent: number = 0;

  private _selectKind: number = 0;
  private _debounceTimeout: any;
  private _errorAddressNotExists: boolean = false;
  private _listSkillsWithoutAddress: string = "";

  //Value of address state for label component
  private _valueLabelButtonAddressState: string = "";
  //List of device kind for label component
  private _deviceKindList = null;

  //Array of strings with values of icons state (for example "On=1#img")
  private _labelButtonIconsState: string[] = [];

  //id of device kind for selected address state
  private _idDeviceKind: number = null;

  public dynamicForm: UntypedFormGroup;
  public fields: any[] = [];
  public showConfigDiv: boolean = true;
  public showAssociationDiv: boolean = false;
  public isPreviewModalOpen: boolean = false;

  //Smart component rendered inside the preview popup; it always reflects the last saved configuration
  public previewSmartComponent: SmartComponent = null;

  //Environment used by the preview to load the environment scoped data (ie. counter measurements)
  public previewIdEnvironment: number = null;
  public previewEnvironmentName: string = "";
  //Text of the preview environment search bar: it goes back to the selected environment when the bar loses the focus
  public previewEnvironmentText: string = "";
  public listPreviewEnvironmentSuggestions: SmartComponentEnvironmentAssociated[] = [];
  public highlightedPreviewEnvironmentIndex: number = -1;
  public isContentVisible: { [key: string]: boolean } = {};
  public selectedValue: any;
  public searchTerm: string = "";
  public searchSkillTerm: string = "";
  public filteredSkillFields: SmartComponentPropertyDetails[] = [];
  public listEnvironmentAssociated: SmartComponentEnvironmentAssociated[] = [];
  public listProperties: SmartComponentProperty;
  public listPropertiesSave: SmartComponentPropertySave =
    new SmartComponentPropertySave();
  public listPropertiesNewSave: SmartComponentNewPropertySave =
    new SmartComponentNewPropertySave();
  public listSkillNewComponent: Skill[] = [];
  public listEnvironments: Environment[] = [];
  public pageBreakEnvironmentList: Environment[] = [];
  public pageBreakEnvironmentName: string = "";
  public addedItems: string[] = [];
  public groupedComponents: GroupedComponents = {};
  public hideMainTab: boolean = true;
  public addressFieldMappings: {
    titleSkill: string;
    address: string;
    instanceGUID: string;
    id: number;
  }[] = [];
  public addressFunctionMappings: {
    titleSkill: string;
    id: number;
    name: string;
  }[] = [];
  //Maps each scenario skill to the selected scenario id (the form control holds the name for display)
  public scenarioFieldMappings: {
    titleSkill: string;
    id: number;
  }[] = [];
  public idSmartComponentSelected: number = 0;
  public insertNewSmartComponent: boolean = false;
  public typeSmartComponentSelected: SmartComponentType;
  public skillFormat = SkillFormat;
  public skillNameList = SkillNameList;
  public enumViewMode = ViewMode;
  public enumImagePosition = ImagePosition;

  public showError: boolean = false;

  public selectedEnvName: string = "";
  public selectedEnvId: number = null;

  //Description of the environment used to filter the list, empty when no filter is active
  public environmentFilterName: string = "";

  //Flag used to reverse keyword fields in label components
  public isReversed: boolean = false;

  //Flag for showing/hiding fields for icons state
  public isLabelButtonIconsStateVisible: boolean = false;

  //Label values for icons state
  public iconsStateFields: string[] = [];

  //Value for input type icons state (changes only when the field is one)
  public iconsStateFieldType: string = "";

  //Flag for indicating if icons state input is only one
  public oneIconStateField: boolean = false;

  public isVimar: boolean = false;
  public isDigitalPlace: boolean = false;

  @Input() isExpanded: boolean = false;
  @Input() type_counter: CounterType = CounterType.COLDWATER;
  @Input() listSmartComponentKind: SmartComponentKind[] = [];
  @Input() listSmartComponent: SmartComponent[] = [];
  @Input() listEnvironmentsOriginal: Environment[] = [];
  @Input() idArea: number = 0;
  @Input() isConfigurationPage: boolean = true;
  @Input() idEnvironmentFilter: number = null;

  readonly reloadSmartComponent = output<any>();
  readonly environmentFilterChange = output<number>();

  constructor() {
    this.dynamicForm = this.fb.group({});
    this.isVimar = this._themeService.isVimar;
    this.isDigitalPlace =
      this._themeService.applicationTheme === ApplicationTheme.DIGITAL_PLACE;
  }

  ngOnInit() {
    this.isDigitalPlace = environment.isDigitalPlace;
    this.reloadForm();

    this._formSubscription = this.checkForFormChanges();

    // Passively listen to the scenario list; the actual fetch is triggered on
    // demand (refreshScenarioListIfNeeded) only when a scenario skill is present
    this._scenarioSubscription = this._scenariosService.scenarioList.subscribe(
      (list: Scenario[]) => {
        this._listScenario = list || [];
        this.refreshScenarioDisplayNames();
      },
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes["listSmartComponent"] || changes["listSmartComponentKind"]) &&
      this.listSmartComponent &&
      this.listSmartComponentKind
    ) {
      this.reloadGroupedComponents(this.searchTerm);
    }

    if (changes["idEnvironmentFilter"] || changes["listEnvironmentsOriginal"]) {
      this.environmentFilterName = this.idEnvironmentFilter
        ? this.getEnvironmentFilterOptions().find(
          (item: Environment) => item.id === this.idEnvironmentFilter,
        )?.descriptionEnvironment ?? ""
        : "";
    }

    //When changing from and to configuration page hide current selected smart component and reset search input/component type dropdown value
    if (
      (changes["isConfigurationPage"] &&
        !changes["isConfigurationPage"].firstChange)
    ) {
      this.resetSelectionAndFilters();
      this.reloadGroupedComponents();
    }
  }

  /**
   * Handle remove icon
   * @param field name of the icon field
   */
  public onClickRemoveIcon(formControl: string, field?: string): void {
    if (formControl && field) {
      this.dynamicForm.get(formControl).patchValue({ [field]: "" });
    } else {
      this.dynamicForm.patchValue({ [formControl]: "" });
    }

    this.dynamicForm.markAsDirty();
  }

  /**
   * Open popup icon when clicking on icons state fields
   * @param field name of the icon field
   * @returns
   */
  public async onClickOpenIconPopup(
    formControl: string,
    field?: string,
  ): Promise<void> {
    const modal = await this._modalController.create({
      component: PopupRepositoryIconComponent,
      animated: true,
      backdropDismiss: true,
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data) {
      if (formControl && field) {
        this.dynamicForm
          .get(formControl)
          .patchValue({ [field]: data.selectedIcon });
      } else {
        this.dynamicForm.patchValue({ [formControl]: data.selectedIcon });
      }

      this.dynamicForm.markAsDirty();
    }
  }

  /**
   * Get the url to show the icon
   * @param field name of the icon field
   * @returns
   */
  public getUrlIcon(formControl: string, field?: string): string {
    if (formControl && field) {
      return (
        AppSettings.URL_ICONS_REPOSITORY +
        encodeURIComponent(this.dynamicForm.get([formControl, field]).value)
      );
    } else {
      return (
        AppSettings.URL_ICONS_REPOSITORY +
        encodeURIComponent(this.dynamicForm.get(formControl).value)
      );
    }
  }

  /**
   * On click reverse keywords fields for label component
   */
  public onClickSwapFields(): void {
    this.isReversed = !this.isReversed;
    this.dynamicForm.markAsDirty();
  }

  /**
   * On click open popup with the list of keywords for label component
   */
  public async onClickOpenPopupKeywords(): Promise<void> {
    const modal = await this._modalCtrl.create({
      component: PopupKeywordComponent,
      componentProps: {
        selectedItem:
          this.dynamicForm.value.LabelButtonFormatting.selectedKeyword,
      },
    });

    modal.present();

    const { data } = await modal.onDidDismiss();

    if (data) {
      this.dynamicForm
        .get("LabelButtonFormatting")
        .patchValue({ selectedKeyword: data });

      this.dynamicForm.markAsDirty();

      if (data === "#decimaldigitsN") {
        (
          this.dynamicForm.get("LabelButtonFormatting") as UntypedFormGroup
        ).addControl(
          "NValue",
          new UntypedFormControl("", [
            Validators.required,
            this.checkIfValueIsNumeric(),
          ]),
          { emitEvent: false },
        );
      } else if (
        data !== "#decimaldigitsN" &&
        this.dynamicForm.get(["LabelButtonFormatting", "NValue"])
      ) {
        (
          this.dynamicForm.get("LabelButtonFormatting") as UntypedFormGroup
        ).removeControl("NValue", { emitEvent: false });
      }
    }
  }

  /**
   * Filter components on search term
   */
  public filterComponents() {
    if (this._debounceTimeout) {
      clearTimeout(this._debounceTimeout);
    }

    this._debounceTimeout = setTimeout(() => {
      this.reloadGroupedComponents(this.searchTerm);
    }, 500);
  }

  /**
   * Handle filtering list of fields for skills when using the searchbar
   * @param event searched term
   */
  public filterSkills(event?: CustomEvent): void {
    if (event) {
      this.searchSkillTerm = (event.detail?.value || "").toString();
    }

    const lowerCaseSearchTerm = this.searchSkillTerm.trim().toLowerCase();

    if (!lowerCaseSearchTerm) {
      this.filteredSkillFields = [...this.fields];
      return;
    }

    this.filteredSkillFields = this.fields.filter(
      (field: SmartComponentPropertyDetails) => {
        const skillDescription = (
          this.getDescriptionSkill(field?.titleSkill) || ""
        ).toLowerCase();

        return skillDescription.includes(lowerCaseSearchTerm);
      },
    );
  }

  /**
   * Reload list smart component by selected kind
   * @param event
   */
  public onSmartComponentKindChange(event) {
    this._selectKind = event.detail.value;

    this.reloadGroupedComponents();
  }

  /**
   * Reload list smart component on deselect option
   */
  public onSmartComponentDeselect() {
    this._selectKind = 0;
    this.reloadGroupedComponents();
    this.selectedValue = null;
  }

  /**
   * Reload grouped components
   */
  public reloadGroupedComponents(searchTerm?: string): void {
    this.groupedComponents = this.listSmartComponent
      .filter((component) =>
        this._selectKind > 0
          ? component.idSmartComponentKind == this._selectKind
          : true,
      )
      .filter((component) =>
        searchTerm && searchTerm.trim() !== ""
          ? component.name
            .toLowerCase()
            .includes(searchTerm.trim().toLowerCase())
          : true,
      )
      .reduce((acc, component) => {
        let groupType = "";
        const componentKind = this.listSmartComponentKind.find(
          (kind) => kind.id === component.idSmartComponentKind,
        );
        if (componentKind.kind == SmartComponentTypeKind.METER) {
          groupType = this._translateService.instant("dictionary.typesMeters");
        }
        if (componentKind.kind == SmartComponentTypeKind.ALARM) {
          groupType = this._translateService.instant("dictionary.typesAlarms");
        }
        if (componentKind.kind == SmartComponentTypeKind.BLINDS) {
          groupType = this._translateService.instant("dictionary.typesBlinds");
        }
        if (componentKind.kind == SmartComponentTypeKind.LIGHTS) {
          groupType = this._translateService.instant("dictionary.typesLights");
        }
        if (componentKind.kind == SmartComponentTypeKind.SENSOR) {
          groupType = this._translateService.instant("dictionary.typesSensors");
        }
        if (componentKind.kind == SmartComponentTypeKind.THERMOSTAT) {
          groupType = this._translateService.instant("dictionary.typesThermostats");
        }
        if (componentKind.kind == SmartComponentTypeKind.WEATHER_STATION) {
          groupType = this._translateService.instant("dictionary.weatherStations");
        }

        if (componentKind.kind == SmartComponentTypeKind.LABEL) {
          groupType = this._translateService.instant("dictionary.labels");
        }
        if (componentKind.kind == SmartComponentTypeKind.PAGE_BREAK) {
          groupType = this._translateService.instant("dictionary.pageBreak");
        }

        if (componentKind.kind == SmartComponentTypeKind.SCENARIO) {
          groupType = this._translateService.instant("dictionary.scenarios");
        }

        if (componentKind) {
          const kind = componentKind.kind;

          if (!acc[kind]) {
            acc[kind] = { name: groupType.toUpperCase(), components: [] };
          }
          component.informalName = this.getDescriptionKind(
            componentKind.id,
          ).toUpperCase();
          acc[kind].components.push(component);
        }
        return acc;
      }, {});

    for (const key in this.groupedComponents) {
      if (this.groupedComponents.hasOwnProperty(key)) {
        if (this.isContentVisible[+key] === undefined) {
          this.isContentVisible[+key] = true;
        }
      }
    }
  }

  /**
   * Get select icon
   * @returns {string}
   */
  public getSelectIcon(): string {
    return IconHelper.getSmartComponentIconByType(
      this.typeSmartComponentSelected,
    );
  }

  /**
   * Returns the smart component type icon based on the provided ID
   * @param idSmartComponentKind
   * @returns {string}
   */
  public getTypeIcon(idSmartComponentKind: number): string {
    return IconHelper.getSmartComponentIconByType(idSmartComponentKind);
  }

  /**
   * Get description kind
   */
  public getDescriptionKind(id: SmartComponentType): string {
    switch (id) {
      case SmartComponentType.ELECTRIC:
        return this._translateService.instant("dictionary.meterElectricity");
      case SmartComponentType.HOT_WATER:
        return this._translateService.instant("dictionary.meterHotWater");
      case SmartComponentType.COLD_WATER:
        return this._translateService.instant("dictionary.meterColdWater");
      case SmartComponentType.HEATING:
        return this._translateService.instant("dictionary.meterHeating");
      case SmartComponentType.DISTRIBUTOR:
        return this._translateService.instant("dictionary.meterDistributor");
      case SmartComponentType.GAS:
        return this._translateService.instant("dictionary.meterGas");
      case SmartComponentType.BLINDS:
        return this._translateService.instant("dictionary.typeBlinds");
      case SmartComponentType.LIGHT:
        return this._translateService.instant("dictionary.typeLights");
      case SmartComponentType.DIMMER:
        return this._translateService.instant("dictionary.typeDimmer");
      case SmartComponentType.ALARM:
        return this._translateService.instant("dictionary.typeAlarm");
      case SmartComponentType.THERMOSTAT:
        return this._translateService.instant("dictionary.thermostat");
      case SmartComponentType.CONTACT:
        return this._translateService.instant("dictionary.typeContact");
      case SmartComponentType.SENSOR:
        return this._translateService.instant("dictionary.typeSensor");
      case SmartComponentType.WEATHER_STATION:
        return this._translateService.instant("dictionary.weatherStation");
      case SmartComponentType.LABEL:
        return this._translateService.instant("dictionary.label");
      case SmartComponentType.SCENARIO:
        return this._translateService.instant("dictionary.scenario");
      case SmartComponentType.PAGE_BREAK:
        return this._translateService.instant("dictionary.pageBreak");
      default:
        return "";
    }
  }

  /**
   * Associate environment to smart component
   */
  public async onClickAddEnvironment() {
    try {
      await this._loaderService.presentLoaderWaiting();
      if (
        this.selectedEnvId &&
        !this.addedItems.includes(this.selectedEnvId.toString())
      ) {
        const smartComponentToAssociate: AssociationSmartComponent = {
          idSmartComponent: this._idSmartComponent,
          idEnvironment: this.selectedEnvId,
        };
        await this._smartComponentService.addAssociateSmartComponentEnvironment(
          [smartComponentToAssociate],
        );
        this.selectedEnvId = null;
        this.selectedEnvName = "";
        await this.refreshEnvironmentAssociated(this.idSmartComponentSelected);
      }
    } catch {
      await this._loaderService.dismissLoaderWaiting();
      this._alertService.presentAlertSomethingWrong();
    } finally {
      await this._loaderService.dismissLoaderWaiting();
    }
  }

  /**
   * Generate single tab icon by key segment value
   *
   * @param keySegment Key segment to get css icon class
   * @returns Css icon class
   */
  public getTabIconClassByCategory(keySegment = 15): string {
    let cssSegmentIconClass: string = "";

    switch (Number(keySegment)) {
      case EnvironmentCategory.FLOOR:
        cssSegmentIconClass = "grid";
        break;
      case EnvironmentCategory.GARAGE:
        cssSegmentIconClass = "car";
        break;
      case EnvironmentCategory.ELAVATOR_FLOOR:
        cssSegmentIconClass = "swap-vertical-outline";
        break;
      case EnvironmentCategory.EXTERNAL_ACCESS:
        cssSegmentIconClass = "enter-outline";
        break;
      case EnvironmentCategory.APARTAMENT:
        cssSegmentIconClass = "home";
        break;
      default:
        cssSegmentIconClass = "cube";
    }

    return cssSegmentIconClass;
  }

  /**
   * Load environments filtered by current idArea, used by the PageBreakIDEnvironment dropdown
   */
  private async loadPageBreakEnvironments(): Promise<void> {
    try {
      const result = await this._environmentService
        .getEnvironments(this.isDigitalPlace ? this.idArea : null, undefined, false, false)
        .toPromise();
      const list: Environment[] = result?.data ?? [];
      const filtered = this.isDigitalPlace
        ? list.filter(
          (item: Environment) =>
            item.category === EnvironmentCategory.APARTAMENT ||
            item.category === EnvironmentCategory.ROOM,
        )
        : list;
      this.pageBreakEnvironmentList = this.buildElaboratedEnvironmentList(
        filtered,
        list,
      );
    } catch {
      this.pageBreakEnvironmentList = [];
    }
  }

  /**
   * Reload form based on template json
   */
  private reloadForm(): void {
    // Clear existent form controls
    Object.keys(this.dynamicForm.controls).forEach((control) => {
      this.dynamicForm.removeControl(control);
    });

    this.fields = this.listSkillNewComponent;
    this.searchSkillTerm = "";
    this.filterSkills();
    this._idSmartComponent = 0;

    if (
      this.fields.some(
        (f) => f.titleSkill === SkillNameList.PAGE_BREAK_ID_ENVIRONMENT,
      )
    ) {
      this.loadPageBreakEnvironments();
    }

    for (let field of this.fields) {

      //Applying validators as needed
      const validators = [];

      if (field.isRequired) {
        validators.push(Validators.required);
      }

      if (field.template && field.template.pattern) {
        validators.push(Validators.pattern(field.template.pattern));
      }
      if (
        field.titleSkill !== "LabelButtonFormatting" &&
        field.titleSkill !== "LabelButtonIconsState"
      ) {
        this.dynamicForm.addControl(
          field.titleSkill,
          this.fb.control("", validators),
        );
      } else {
        this.dynamicForm.addControl(
          field.titleSkill,
          new UntypedFormGroup({}),
          {
            emitEvent: false,
          },
        );

        if (field.titleSkill === "LabelButtonFormatting") {
          (
            this.dynamicForm.get("LabelButtonFormatting") as UntypedFormGroup
          ).addControl(
            "selectedKeyword",
            new UntypedFormControl("#formattedvalue", Validators.required),
            { emitEvent: false },
          );
          (
            this.dynamicForm.get("LabelButtonFormatting") as UntypedFormGroup
          ).addControl(
            "additionalKeyword",
            new UntypedFormControl("", this.checkIfThereAreHashtags()),
            { emitEvent: false },
          );
        }
      }

      // If an address has a default value (its id) search for the name of the skill and print it on the field
      if (field.dataFormat === SkillFormat.ADDRESS && field.default) {
        this._addressService
          .getAddressesForSmartComponent(`idAddress=${field.default}`)
          .subscribe((item) =>
            this.dynamicForm
              .get(field.titleSkill)
              .setValue(item.items[0].address),
          );
      }

      if (field.titleSkill !== "LabelButtonFormatting") {
        const valueToSet =
          field.titleSkill === SkillNameList.PAGE_BREAK_MODE && !field.default
            ? "0"
            : field.default;
        this.dynamicForm.get(field.titleSkill).setValue(valueToSet);
      }
    }

    this.pageBreakEnvironmentName = "";

    this.refreshScenarioListIfNeeded();
  }

  /**
   * When the selected smart component exposes a scenario skill, fetch the
   * updated scenario list so the search-select popup shows current data.
   */
  private refreshScenarioListIfNeeded(): void {
    const hasScenarioField = (this.fields || []).some(
      (field) => field.dataFormat === SkillFormat.SCENARIO,
    );

    if (hasScenarioField) {
      this._scenariosService.reloadServiceData();
    }
  }

  ngOnDestroy() {
    this._formSubscription?.unsubscribe();
    this._environmentDataSubscription?.unsubscribe();
    this._scenarioSubscription?.unsubscribe();

    // Reset value in search address skill component when leaving the page
    this._smartComponentService.searchAdressesFieldsValue.next({
      name: "",
      address: "",
    });
  }

  /**
   * On click open address
   * @param field
   */
  public async onClickOpenAddress(field: any) {
    if (field.dataFormat === SkillFormat.ADDRESS) {
      const modal = await this._modalCtrl.create({
        component: SearchAddressComponent,
        cssClass: "modal-bigger",
        componentProps: {
          idArea: this.idArea,
          includeVariable: 0,
          keepSearchFields: true,
          useSimpleData: true,
          loadCompleteAddresses: false,
          showAddressDetails: false,
          title:
            field.titleSkill !== "LabelButtonAddressState" &&
              field.titleSkill !== "LabelButtonAddressCommand" &&
              this._themeService.applicationTheme !==
              ApplicationTheme.DIGITAL_PLACE
              ? this._translateService.instant("dictionary.selectAddressOrAddressFunction")
              : this._translateService.instant("dictionary.selectAddress"),
          showAddressFunction:
            field.titleSkill !== "LabelButtonAddressState" &&
              field.titleSkill !== "LabelButtonAddressCommand" &&
              this._themeService.applicationTheme !==
              ApplicationTheme.DIGITAL_PLACE
              ? true
              : false,
        },
      });

      modal.present();

      const { data } = await modal.onWillDismiss();

      if (data?.action == "confirm" && data?.selectedValue) {
        this.dynamicForm.markAsDirty();

        if (field.titleSkill === "LabelButtonAddressState") {
          Object.keys(
            this.dynamicForm.controls["LabelButtonIconsState"]["controls"],
          ).forEach((control) => {
            (
              this.dynamicForm.get("LabelButtonIconsState") as UntypedFormGroup
            ).removeControl(control);
          });
          this.isLabelButtonIconsStateVisible = false;
        }

        if (data?.selectedType == SelectionAddressOrAddressFunction.ADDRESS) {
          this._idDeviceKind = data.selectedValue.idDeviceKind;
          this.dynamicForm
            .get(field.titleSkill)
            ?.setValue(
              `${data?.selectedValue?.address || ""} ${data?.selectedValue?.name || ""
              }`,
            );
        } else if (
          data?.selectedType ==
          SelectionAddressOrAddressFunction.ADDRESS_FUNCTION
        ) {
          this.dynamicForm
            .get(field.titleSkill)
            ?.setValue(`#${data?.selectedValue?.name || ""}`);
        }

        if (data?.selectedType == SelectionAddressOrAddressFunction.ADDRESS) {
          const existingIndex = this.addressFieldMappings.findIndex(
            (item) => item.titleSkill === field.titleSkill,
          );

          if (existingIndex !== -1) {
            this.addressFieldMappings[existingIndex].address =
              data?.selectedValue.address;
            this.addressFieldMappings[existingIndex].instanceGUID =
              data?.selectedValue.instanceGUID;
            this.addressFieldMappings[existingIndex].id =
              data?.selectedValue.id;
          } else {
            this.addressFieldMappings.push({
              titleSkill: field.titleSkill,
              address: data?.selectedValue.address,
              instanceGUID: data?.selectedValue.instanceGUID,
              id: data?.selectedValue.id,
            });
          }

          const existingIndexFunction = this.addressFunctionMappings.findIndex(
            (item) => item.titleSkill === field.titleSkill,
          );
          if (existingIndexFunction !== -1) {
            this.addressFunctionMappings.splice(existingIndexFunction, 1);
          }
        } else if (
          data?.selectedType ==
          SelectionAddressOrAddressFunction.ADDRESS_FUNCTION
        ) {
          const existingIndex = this.addressFunctionMappings.findIndex(
            (item) => item.titleSkill === field.titleSkill,
          );

          if (existingIndex !== -1) {
            this.addressFunctionMappings[existingIndex].id =
              data?.selectedValue.id;
            this.addressFunctionMappings[existingIndex].name =
              data?.selectedValue.name;
          } else {
            this.addressFunctionMappings.push({
              titleSkill: field.titleSkill,
              id: data?.selectedValue.id,
              name: data?.selectedValue.name,
            });
          }

          const existingIndexAddress = this.addressFieldMappings.findIndex(
            (item) => item.titleSkill === field.titleSkill,
          );
          if (existingIndexAddress !== -1) {
            this.addressFieldMappings.splice(existingIndexAddress, 1);
          }
        }
      }

      if (modal) {
        modal.dismiss();
      }
    }
  }

  /**
   * On click clear address or address function
   * @param titleSkill
   */
  public onClickClearAddress(titleSkill) {
    const controlSkill = this.dynamicForm.get(titleSkill);
    this.isLabelButtonIconsStateVisible = false;

    if (controlSkill) {
      controlSkill.setValue("");
      controlSkill.markAsTouched();
      controlSkill.markAsDirty();
      controlSkill.updateValueAndValidity();

      const existingIndex = this.addressFieldMappings.findIndex(
        (item) => item.titleSkill === titleSkill,
      );

      if (existingIndex !== -1) {
        this.addressFieldMappings.splice(existingIndex, 1);
      }

      const existingIndexAddress = this.addressFunctionMappings.findIndex(
        (item) => item.titleSkill === titleSkill,
      );

      if (existingIndexAddress !== -1) {
        this.addressFunctionMappings.splice(existingIndexAddress, 1);
      }
    }
  }

  /**
   * Translation key of the description of each skill, by skill title.
   * We build it once because the template calls getDescriptionSkill for every field at every change detection
   */
  private static readonly TITLE_SKILL_TRANSLATION_KEYS: Readonly<Record<string, string>> = {
    BlindCloseCommand: "dictionary.blindCloseCommand",
    BlindHeightState: "dictionary.blindHeightState",
    BlindHeightCommand: "dictionary.blindHeightCommand",
    BlindOpenCommand: "dictionary.blindOpenCommand",
    BlindsDescription: "dictionary.blindsDescription",
    BlindsName: "dictionary.blindsName",
    BlindStopCommand: "dictionary.blindStopCommand",
    ColdWaterFlow: "dictionary.coldWaterFlow",
    ColdWaterMeterDescription: "dictionary.coldWaterMeterDescription",
    ColdWaterMeterName: "dictionary.coldWaterMeterName",
    ColdWaterVolume: "dictionary.coldWaterVolume",
    DimmerCommand: "dictionary.dimmerCommand",
    DimmerOnOffCommand: "dictionary.dimmerOnOffCommand",
    DimmerOnOffState: "dictionary.dimmerOnOffState",
    DimmerState: "dictionary.dimmerState",
    DimmingDescription: "dictionary.dimmingDescription",
    DimmingName: "dictionary.dimmingName",
    DistributorConsumption: "dictionary.distributorConsumption",
    DistributorDescription: "dictionary.distributorDescription",
    DistributorName: "dictionary.distributorName",
    ElectricActivePower: "dictionary.electricActivePower",
    ElectricEnergyAbsorbed: "dictionary.electricEnergyAbsorbed",
    ElectricEnergyProduced: "dictionary.electricEnergyProduced",
    ElectricityMeterDescription: "dictionary.electricityMeterDescription",
    ElectricityMeterName: "dictionary.electricityMeterName",
    ElectricPowerExchange: "dictionary.electricPowerExchange",
    GasMeterDescription: "dictionary.gasMeterDescription",
    GasMeterName: "dictionary.gasMeterName",
    GasVolume: "dictionary.gasVolume",
    HeatingMeterDescription: "dictionary.heatingMeterDescription",
    HeatingMeterName: "dictionary.heatingMeterName",
    HeatPowerActive: "dictionary.thermalPower",
    HeatThermalEnergy: "dictionary.thermalEnergy",
    HeatVolume: "dictionary.heatVolume",
    HotWaterFlow: "dictionary.hotWaterFlow",
    HotWaterMeterDescription: "dictionary.hotWaterMeterDescription",
    HotWaterMeterName: "dictionary.hotWaterMeterName",
    HotWaterVolume: "dictionary.hotWaterVolume",
    LightOnOffCommand: "dictionary.lightOnOffCommand",
    LightOnOffDescription: "dictionary.lightOnOffDescription",
    LightOnOffName: "dictionary.lightOnOffName",
    LightOnOffState: "dictionary.lightOnOffState",
    SwitchCommand: "dictionary.switchCommand",
    SwitchDescription: "dictionary.switchDescription",
    SwitchName: "dictionary.switchName",
    SwitchState: "dictionary.switchState",
    ThermostatName: "dictionary.thermostatName",
    ThermostatDescription: "dictionary.thermostatDescription",
    ActualTemperature: "dictionary.actualTemperature",
    BaseSetpoint: "dictionary.baseSetpoint",
    BaseSetpointMin: "dictionary.min",
    BaseSetpointMax: "dictionary.max",
    HeatingCooling: "dictionary.heatingCooling",
    HeatingCoolingState: "dictionary.heatingCoolingState",
    ValveState: "dictionary.valveState",
    HVACMode: "dictionary.hvacMode",
    HVACModeState: "dictionary.hvacModeState",
    Comfort: "dictionary.comfort",
    Standby: "dictionary.standby",
    Economy: "dictionary.economy",
    Protection: "dictionary.protection",
    SetpointCoolingComfort: "dictionary.setpointCoolingComfort",
    SetpointCoolingComfortMin: "dictionary.min",
    SetpointCoolingComfortMax: "dictionary.max",
    SetpointCoolingStandby: "dictionary.setpointCoolingStandby",
    SetpointCoolingStandbyMin: "dictionary.min",
    SetpointCoolingStandbyMax: "dictionary.max",
    SetpointCoolingEconomy: "dictionary.setpointCoolingEconomy",
    SetpointCoolingEconomyMin: "dictionary.min",
    SetpointCoolingEconomyMax: "dictionary.max",
    SetpointCoolingProtection: "dictionary.setpointCoolingProtection",
    SetpointCoolingProtectionMin: "dictionary.min",
    SetpointCoolingProtectionMax: "dictionary.max",
    SetpointHeatingComfort: "dictionary.setpointComfort",
    SetpointHeatingComfortMin: "dictionary.min",
    SetpointHeatingComfortMax: "dictionary.max",
    SetpointHeatingStandby: "dictionary.setpointStandby",
    SetpointHeatingStandbyMin: "dictionary.min",
    SetpointHeatingStandbyMax: "dictionary.max",
    SetpointHeatingEconomy: "dictionary.setpointEconomy",
    SetpointHeatingEconomyMin: "dictionary.min",
    SetpointHeatingEconomyMax: "dictionary.max",
    SetpointHeatingProtection: "dictionary.setpointProtection",
    SetpointHeatingProtectionMin: "dictionary.min",
    SetpointHeatingProtectionMax: "dictionary.max",
    WindowsOpenState: "dictionary.windowsOpenState",
    FancoilCommand: "dictionary.fancoilCommand",
    FancoilCommandMin: "dictionary.min",
    FancoilCommandMax: "dictionary.max",
    FancoilState: "dictionary.fancoilState",
    FancoilStateMin: "dictionary.min",
    FancoilStateMax: "dictionary.max",
    FancoilV0: "dictionary.fancoilV0",
    FancoilV1: "dictionary.fancoilV1",
    FancoilV2: "dictionary.fancoilV2",
    FancoilV3: "dictionary.fancoilV3",
    FancoilAutoMan: "dictionary.fancoilAutoMan",
    FancoilAutoManState: "dictionary.fancoilAutoManState",
    ActualSetpointActualSummerSetpoint: "dictionary.actualSetPoint/summerSetpoint",
    ActualWinterSetpoint: "dictionary.actualWinterSetpoint",
    AlarmName: "dictionary.alarmName",
    AlarmDescription: "dictionary.alarmDescription",
    AlarmState: "dictionary.alarmState",
    AlarmReset: "dictionary.alarmReset",
    Inverted: "dictionary.alarmInverted",
    SlatPositionCommand: "dictionary.slatPositionCommand",
    SlatPositionCommandMin: "dictionary.min",
    SlatPositionCommandMax: "dictionary.max",
    SlatPositionState: "dictionary.slatPositionState",
    SensorName: "dictionary.sensorName",
    SensorDescription: "dictionary.sensorDescription",
    SensorPresence: "dictionary.sensorPresence",
    SensorAmbientBrightness: "dictionary.sensorAmbientBrightness",
    SensorAmbientBrightnessSetpoint: "dictionary.sensorAmbientBrightnessSetpoint",
    SensorAmbientBrightnessSetpointMin: "dictionary.min",
    SensorAmbientBrightnessSetpointMax: "dictionary.max",
    SensorStateAutoMan: "dictionary.sensorStateAutoMan",
    SensorCommandAutoMan: "dictionary.sensorCommandAutoMan",
    SensorOnOffCommand: "dictionary.dimmerOnOffCommand",
    SensorOnOffState: "dictionary.dimmerOnOffState",
    SensorCommand: "dictionary.dimmerCommand",
    SensorState: "dictionary.dimmerState",
    FaultState: "dictionary.faultState",
    SensorFaultState: "dictionary.faultState",
    SensorDimmerName: "dictionary.dimmingName",
    SensorCurrentColorTemperature: "dictionary.sensorCurrentColorTemperature",
    SensorSetpointColorTemperature: "dictionary.sensorSetpointColorTemperature",
    SensorSetpointColorTemperatureMin: "dictionary.min",
    SensorSetpointColorTemperatureMax: "dictionary.max",
    SensorStateColorTemperature: "dictionary.sensorStateColorTemperature",
    SensorColorTemperatureAutoMan: "dictionary.sensorColorTemperatureAutoMan",
    WeatherStationName: "dictionary.weatherStationName",
    WeatherStationDescription: "dictionary.weatherStationDescription",
    WeatherStationSunsetTime: "dictionary.weatherStationSunsetTime",
    WeatherStationSunriseTime: "dictionary.weatherStationSunriseTime",
    WeatherStationIsDayNight: "dictionary.weatherStationIsDayNight",
    WeatherStationIsDayValue: "dictionary.weatherStationIsDayValue",
    WeatherStationWindSpeed: "dictionary.weatherStationWindSpeed",
    WeatherStationWindAlarm: "dictionary.weatherStationWindAlarm",
    WeatherStationRainAlarm: "dictionary.weatherStationRainAlarm",
    LabelButtonName: "dictionary.labelButtonName",
    LabelButtonDefaultImage: "dictionary.labelButtonDefaultImage",
    LabelButtonOrientation: "dictionary.labelButtonOrientation",
    LabelButtonFormatting: "dictionary.labelButtonFormatting",
    LabelButtonAddressCommand: "dictionary.labelButtonAddressCommand",
    LabelButtonAddressState: "dictionary.labelButtonAddressState",
    LabelButtonIconsState: "dictionary.labelButtonIconsState",
    PageBreakName: "dictionary.pageBreakName",
    PageBreakDescription: "dictionary.pageBreakDescription",
    PageBreakShowDescription: "dictionary.pageBreakShowDescription",
    PageBreakIcon: "dictionary.pageBreakIcon",
    PageBreakIDEnvironment: "dictionary.pageBreakIDEnvironment",
    PageBreakMode: "dictionary.pageBreakMode",
    WeatherStationActualTemperature: "dictionary.weatherStationActualTemperature",
    WeatherStationAmbientBrightness: "dictionary.weatherStationAmbientBrightness",
    ShiftSetpoint: "dictionary.thermostatShiftSetpoint",
    ShiftSetpointMin: "dictionary.min",
    ShiftSetpointMax: "dictionary.max",
    ActiveEnergyImportedPreviousDayF1: "dictionary.electricActiveEnergyImportedPreviousDayF1",
    ActiveEnergyImportedPreviousDayF2: "dictionary.electricActiveEnergyImportedPreviousDayF2",
    ActiveEnergyImportedPreviousDayF3: "dictionary.electricActiveEnergyImportedPreviousDayF3",
    ActiveEnergyImportedPreviousDayF4: "dictionary.electricActiveEnergyImportedPreviousDayF4",
    ActiveEnergyImportedPreviousDayF5: "dictionary.electricActiveEnergyImportedPreviousDayF5",
    ActiveEnergyImportedPreviousDayF6: "dictionary.electricActiveEnergyImportedPreviousDayF6",
    ElectricActivePowerMax24h: "dictionary.electricActivePowerMax24h",
    ElectricActivePowerFed: "dictionary.electricActivePowerFed",
    ElectricActivePowerFedMax24h: "dictionary.electricActivePowerFedMax24h",
    ScenarioName: "dictionary.scenarioName",
    ScenarioDescription: "dictionary.scenarioDescription",
    Scenario: "dictionary.scenario",
  };

  /**
   * Convert skill into description
   * @param titleSkill
   * @returns
   */
  public getDescriptionSkill(titleSkill: string) {
    const translationKey = ConfigurationSmartComponentComponent.TITLE_SKILL_TRANSLATION_KEYS[titleSkill];
    return translationKey ? this._translateService.instant(translationKey) || null : null;
  }
  /**
   * On click delete smart component
   */
  public async onClickDeleteSmartComponent() {
    try {
      if (
        await this._alertService.presentAlertConfirmOrDismiss(
          "",
          this._translateService.instant("dictionary.confirmDelete"),
          "",
        )
      ) {
        await this._loaderService.presentLoaderWaiting();
        await this._smartComponentService.deleteSmartComponent(
          this.idSmartComponentSelected,
        );
        this.reloadSmartComponent.emit(this.idArea);
        this.hideMainTab = true;
        await this._loaderService.dismissLoaderWaiting();
      }
    } catch {
      await this._loaderService.dismissLoaderWaiting();
      await this._alertService.presentAlertSomethingWrong();
    }
  }

  /**
   * Get column size based on title skill
   * @param titleSkill
   * @returns
   */
  public getColumnSize(titleSkill: string): string {
    const skillsWithWidth4 = [
      "SetpointCoolingComfort",
      "SetpointCoolingComfortMin",
      "SetpointCoolingComfortMax",
      "SetpointCoolingStandby",
      "SetpointCoolingStandbyMin",
      "SetpointCoolingStandbyMax",
      "SetpointCoolingEconomy",
      "SetpointCoolingEconomyMin",
      "SetpointCoolingEconomyMax",
      "SetpointCoolingProtection",
      "SetpointCoolingProtectionMin",
      "SetpointCoolingProtectionMax",
      "SetpointHeatingComfort",
      "SetpointHeatingComfortMin",
      "SetpointHeatingComfortMax",
      "SetpointHeatingStandby",
      "SetpointHeatingStandbyMin",
      "SetpointHeatingStandbyMax",
      "SetpointHeatingEconomy",
      "SetpointHeatingEconomyMin",
      "SetpointHeatingEconomyMax",
      "SetpointHeatingProtection",
      "SetpointHeatingProtectionMin",
      "SetpointHeatingProtectionMax",
      "BaseSetpoint",
      "BaseSetpointMin",
      "BaseSetpointMax",
      "FancoilCommand",
      "FancoilCommandMin",
      "FancoilCommandMax",
      "FancoilState",
      "FancoilStateMin",
      "FancoilStateMax",
      "SlatPositionCommand",
      "SlatPositionCommandMin",
      "SlatPositionCommandMax",
      "SensorAmbientBrightnessSetpoint",
      "SensorAmbientBrightnessSetpointMin",
      "SensorAmbientBrightnessSetpointMax",
      "SensorSetpointColorTemperature",
      "SensorSetpointColorTemperatureMin",
      "SensorSetpointColorTemperatureMax",
      "ShiftSetpoint",
      "ShiftSetpointMin",
      "ShiftSetpointMax",
    ];

    if (skillsWithWidth4.includes(titleSkill)) {
      return "4";
    } else {
      return "12";
    }
  }

  /**
   * On click view smart component
   * @returns
   */
  public async onClickViewSmartComponent(idSmartcomponent: number) {
    try {
      await this._loaderService.presentLoaderWaiting();
      // Reset show error flag when trying to load component
      this.showError = false;

      // Reset value in search address skill component when opening a different smart component
      this._smartComponentService.searchAdressesFieldsValue.next({
        name: "",
        address: "",
      });

      this._errorAddressNotExists = false;
      this._listSkillsWithoutAddress = "";
      this.insertNewSmartComponent = false;
      this.hideMainTab = true;
      this.showConfigDiv = true;
      this.showAssociationDiv = false;
      this.isPreviewModalOpen = false;
      this.idSmartComponentSelected = idSmartcomponent;
      this.addressFieldMappings = [];
      this.addressFunctionMappings = [];
      this.scenarioFieldMappings = [];
      this.selectedEnvId = null;
      this.selectedEnvName = null;
      this.iconsStateFieldType = "";
      this.isLabelButtonIconsStateVisible = false;
      this._valueLabelButtonAddressState = null;
      this._idDeviceKind = null;
      this.pageBreakEnvironmentName = "";

      this.listProperties =
        await this._smartComponentService.getSmartComponentSkillsByIDSmartComponent(
          idSmartcomponent,
        );

      this.typeSmartComponentSelected =
        this.listProperties.idSmartComponentKind;

      await this.refreshEnvironmentAssociated(idSmartcomponent);

      const parsedTemplate: SmartComponentProperty = this.listProperties;

      if (!parsedTemplate.skills || !Array.isArray(parsedTemplate.skills)) {
        throw new Error(
          "Configuration-smart-component.component - onClickViewSmartComponent() - Invalid skills array",
        );
      }

      // Pre-load PageBreak environments BEFORE clearing the form, so the template
      // doesn't transiently bind formControlName to controls that don't exist yet.
      if (
        parsedTemplate.skills.some(
          (f) => f.titleSkill === SkillNameList.PAGE_BREAK_ID_ENVIRONMENT,
        )
      ) {
        await this.loadPageBreakEnvironments();
      }

      //We "clear" the last "dinamic" form previously built, in order to repopulate it with the controls for the skills of the newly selected smartComponent
      Object.keys(this.dynamicForm.controls).forEach((control) => {
        this.dynamicForm.removeControl(control);
      });

      this._idSmartComponent = idSmartcomponent;

      this.fields = parsedTemplate.skills;
      this.searchSkillTerm = "";
      this.filterSkills();

      this.refreshScenarioListIfNeeded();

      /*
      WE repopulate the form with the controls for each skills of the newly selected smartComponent
      */
      for (let field of this.fields) {
        //Applying validators as needed

        const validators = [];
        if (field.isRequired) {
          validators.push(Validators.required);
        }

        if (field.template && field.template.pattern) {
          validators.push(Validators.pattern(field.template.pattern));
        }

        if (field.titleSkill === "LabelButtonAddressState" && field.value) {
          this._valueLabelButtonAddressState = field.value;
        }

        if (
          field.titleSkill !== "LabelButtonFormatting" &&
          field.titleSkill !== "LabelButtonIconsState"
        ) {
          const defaultValue =
            field.titleSkill === SkillNameList.PAGE_BREAK_MODE ? "0" : "";
          const control = this.fb.control(
            field.value || defaultValue,
            validators,
          );
          this.dynamicForm.addControl(field.titleSkill, control, {
            emitEvent: false,
          });
        } else {
          this.dynamicForm.addControl(
            field.titleSkill,
            new UntypedFormGroup({}),
            {
              emitEvent: false,
            },
          );

          if (field.titleSkill === "LabelButtonFormatting") {
            (
              this.dynamicForm.get("LabelButtonFormatting") as UntypedFormGroup
            ).addControl(
              "selectedKeyword",
              new UntypedFormControl("#formattedvalue", Validators.required),
              { emitEvent: false },
            );
            (
              this.dynamicForm.get("LabelButtonFormatting") as UntypedFormGroup
            ).addControl(
              "additionalKeyword",
              new UntypedFormControl("", this.checkIfThereAreHashtags()),
              { emitEvent: false },
            );
          }
        }

        /*
        if (!field.isWritable) {
          control.disable();

          */

        //Setting initial value of form
        if (field.dataFormat === SkillFormat.ADDRESS) {
          if (field?.address) {
            const address = field?.address?.address?.trim() || "";
            const name = field?.address?.name?.trim() || "";

            const result =
              address && name ? `${address} ${name}` : `${address}${name}`;

            this.dynamicForm.get(field.titleSkill)?.setValue(result);
          }
          if (field?.addressFunction && field.isAddressFunction) {
            const name = field?.addressFunction?.name?.trim() || "";
            this.dynamicForm.get(field.titleSkill)?.setValue(`#${name}`);
          }

          if (field?.value && !field?.address && !field?.addressFunction) {
            this._errorAddressNotExists = true;
            if (this._listSkillsWithoutAddress) {
              this._listSkillsWithoutAddress += ", ";
            }
            this._listSkillsWithoutAddress += this.getDescriptionSkill(
              field.titleSkill,
            );
          }
        } else {
          if (field.titleSkill === "LabelButtonFormatting") {
            this.isReversed = !field.value.startsWith("#");
            const isDecimalDigits = field.value.includes("#decimaldigits");

            //If isReversed is false split by empty space, else by keywords
            const values = !this.isReversed
              ? field.value.split(/(?<=^\S+)\s/).filter((item: string) => item)
              : field.value
                .split(AppSettings.PATTERN_LABEL_BUTTON_KEYWORD)
                .filter((item: string) => item);

            this.dynamicForm.get(field.titleSkill).setValue({
              selectedKeyword: isDecimalDigits
                ? "#decimaldigitsN"
                : values.filter((item: string) => item.startsWith("#"))[0],
              additionalKeyword:
                values.filter((item: string) => !item.startsWith("#"))[0] ?? "",
            });

            if (isDecimalDigits) {
              (
                this.dynamicForm.get(
                  "LabelButtonFormatting",
                ) as UntypedFormGroup
              ).addControl(
                "NValue",
                new UntypedFormControl(
                  !this.isReversed
                    ? values
                      .filter((item: string) => item.startsWith("#"))[0]
                      .split("#decimaldigits")[1]
                    : values[values.indexOf("#decimaldigits") + 1],
                  [Validators.required, this.checkIfValueIsNumeric()],
                ),
                { emitEvent: false },
              );
            }
          } else if (
            field.titleSkill === "LabelButtonIconsState" &&
            this._valueLabelButtonAddressState
          ) {
            const address = await this._addressService
              .getAddressesForSmartComponent(
                `idAddress=${this._valueLabelButtonAddressState}`,
              )
              .toPromise();

            //Add fields only if deviceKind exists (when idDeviceKind is not -1)
            if (address?.items[0]?.idDeviceKind !== -1) {
              if (!this._deviceKindList) {
                this._deviceKindList =
                  await this._smartComponentService.getAllDeviceKind();
              }

              const deviceKind = this._deviceKindList.filter(
                (item: any) => item.id === address?.items[0].idDeviceKind,
              );

              //Get the names for input labels according to translation
              const fieldsString: string = this.getIconsStateFieldsTranslation(
                deviceKind[0],
              );
              const inputNames = fieldsString.split("|");

              //Get saved value
              const inputValues = field.value.split("|");

              if (inputValues.length === 1 && !fieldsString[0].includes("=")) {
                const inputName = inputNames[0];
                const value = inputValues[0].split("#");
                this.iconsStateFields = [inputName];
                // Create form control and add saved value
                (
                  this.dynamicForm.get(
                    "LabelButtonIconsState",
                  ) as UntypedFormGroup
                ).addControl(
                  inputName,
                  new UntypedFormControl(value[0].split("=")[1]),
                  { emitEvent: false },
                );
                (
                  this.dynamicForm.get(
                    "LabelButtonIconsState",
                  ) as UntypedFormGroup
                ).addControl("icon", new UntypedFormControl(value[1]), {
                  emitEvent: false,
                });

                //Add specific validators and input type
                this.addTypeAndValidatorsToIconsState(
                  inputName,
                  deviceKind[0]["gatewayDataFormat"],
                );
                this.oneIconStateField = true;
              } else {
                //Label of input fields
                this.iconsStateFields = inputNames
                  .filter((item) => item.includes("="))
                  .map((item: string) => item.split("=")[0]);

                //Add value to form controls
                this.iconsStateFields.forEach((item: string, index: number) => {
                  const img = inputValues[index].split("#")[1];
                  (
                    this.dynamicForm.get(
                      "LabelButtonIconsState",
                    ) as UntypedFormGroup
                  ).addControl(item, new UntypedFormControl(img), {
                    emitEvent: false,
                  });
                });

                this.oneIconStateField = false;
              }

              //Create array of string with values (for example "On=1#img")
              if (this.oneIconStateField) {
                this._labelButtonIconsState = inputValues;
              } else {
                this._labelButtonIconsState = inputNames
                  .filter((item) => item.includes("="))
                  .map((item: string, index: number) => {
                    const value = inputValues[index].split("#")[1];
                    return `${item}#${value}`;
                  });
              }

              this.isLabelButtonIconsStateVisible = true;
            } else {
            }
          } else {
            this.dynamicForm
              .get(field.titleSkill)
              ?.setValue(
                field.value || this.setFormPlaceHolderValue(field.dataFormat),
              );
          }
        }
      }

      parsedTemplate.skills.forEach((field) => {
        if (field.dataFormat === SkillFormat.ADDRESS) {
          if (field?.address) {
            this.addressFieldMappings.push({
              titleSkill: field.titleSkill,
              address: field.address.address,
              instanceGUID: field.address.instanceGUID,
              id: field.address.id,
            });
          }
          if (field?.addressFunction) {
            this.addressFunctionMappings.push({
              titleSkill: field.titleSkill,
              id: field.addressFunction.id,
              name: field.addressFunction.name,
            });
          }
        } else if (field.dataFormat === SkillFormat.SCENARIO && field.value) {
          this.setScenarioFieldMapping(field.titleSkill, Number(field.value));
        }
      });

      // Resolve scenario ids to their name for display (list is already in memory)
      this.refreshScenarioDisplayNames();
      this.refreshPageBreakEnvironmentName();

      //The form has just been filled with the saved values, so it has no pending changes
      this.dynamicForm.markAsPristine();

      this.hideMainTab = false;

      await this._loaderService.dismissLoaderWaiting();
      if (this._errorAddressNotExists) {
        await this._alertService.presentAlertOk(
          "",
          this._translateService.instant("dictionary.attention"),
          this._translateService.instant("dictionary.errorAddressNotExists") +
          "<br>" +
          this._listSkillsWithoutAddress,
        );
      }
    } catch (error) {
      await this._loaderService.dismissLoaderWaiting();

      //Reset hideMainTab in order to show error message
      this.hideMainTab = false;

      //Show error message when cannot loading data
      this.showError = true;
    }
  }

  /**
   * Return the "placeholder" value to be assign to the form associated to a peculiar skill, based on the its "dataFormat".
   * @param currentSkillFormat The "dataFormat" of the considered skill
   * @returns The "placeholder" value. It can be a string or a BOOLEAN value.
   */
  public setFormPlaceHolderValue(currentSkillFormat: SkillFormat): any {
    let res = null;
    switch (currentSkillFormat) {
      case SkillFormat.ADDRESS:
        res = this._translateService.instant("dictionary.selectAddress");
        break;
      case SkillFormat.BOOLEAN:
        res = false;
        break;
      case SkillFormat.SCENARIO:
        res = this._translateService.instant("dictionary.selectScenario");
        break;
      case SkillFormat.TEXT:
      default:
        res = "";
        break;
    }
    return res;
  }

  /**
   * Refresh environment associated
   * @param idSmartComponent
   */
  private async refreshEnvironmentAssociated(
    idSmartComponent: number,
  ): Promise<void> {
    await this.loadEnvironmentAssociated(idSmartComponent);

    this.addParentDescriptionToEnviromentAssociated();

    this.addCategoryToEnvironmentAssociated();
    this._hideDataService.envAssociatedOriginalData.next(
      this.listEnvironmentAssociated,
    );
    this._environmentDataSubscription = this.showCorrectEnvironmentsList();

    const elaboratedList = this.getElaboratedListEnvironment();

    this.sortByDescription(elaboratedList);

    this.listEnvironments = elaboratedList;
    this._hideDataService.envOriginalData.next(this.listEnvironments);
    this._environmentDataSubscription = this.showCorrectEnvironmentsList();
  }

  /**
   * Load environment associated to smart component
   * @param idSmartComponent
   */
  private async loadEnvironmentAssociated(
    idSmartComponent: number,
  ): Promise<void> {
    // Fetch the associated environments from the service
    this.listEnvironmentAssociated =
      await this._smartComponentService.getEnvironmentByIdSmartComponent(
        idSmartComponent,
      );
  }

  /**
   * Elaborate associated environments to add parent description to the environment name
   */
  private addParentDescriptionToEnviromentAssociated(): void {
    this.listEnvironmentAssociated = this.listEnvironmentAssociated.map(
      (item) => {
        if (item.idEnvironment > 0) {
          const childEnvironment = this.listEnvironmentsOriginal.find(
            (childItem) => childItem.id === item.idEnvironment,
          );

          if (childEnvironment) {
            const parent = this.listEnvironmentsOriginal.find(
              (parentItem: Environment) =>
                parentItem.id === childEnvironment.idParent,
            );

            if (parent) {
              return {
                ...item,
                environmentName: `${parent.descriptionEnvironment} - ${childEnvironment.descriptionEnvironment}`,
              };
            }
          }
        }

        return item;
      },
    );
  }

  /**
   * Add category information to each associated environment
   */
  private addCategoryToEnvironmentAssociated(): void {
    this.listEnvironmentAssociated = this.listEnvironmentAssociated.map(
      (associated) => {
        const environment = this.listEnvironmentsOriginal.find(
          (env) => env.id === associated.idEnvironment,
        );
        return {
          ...associated,
          category: environment ? environment.category : null,
        };
      },
    );
  }

  /**
   * Elaborate list of environments to be shown in the list
   * Add parent description to the child environments
   * @returns
   */
  private getElaboratedListEnvironment(): any[] {
    const listEnvironmentTemp: Environment[] = this.listEnvironmentsOriginal.filter(
      (item: Environment) => {
        // Digital Place shows only environments of type apartment and room
        if (
          this.isDigitalPlace &&
          item.category !== EnvironmentCategory.APARTAMENT &&
          item.category !== EnvironmentCategory.ROOM
        ) {
          return false;
        }

        // An environment already associated can't be chosen again
        return !this.listEnvironmentAssociated.some(
          (associated) => associated.idEnvironment === item.id,
        );
      },
    );

    return this.buildElaboratedEnvironmentList(
      listEnvironmentTemp,
      this.listEnvironmentsOriginal,
    );
  }

  /**
   * Flatten environments as parents followed by their children, with each
   * child's description prefixed by the parent's description. Children whose
   * parent isn't in `filtered` are still resolved against `original`.
   */
  private buildElaboratedEnvironmentList(
    filtered: Environment[],
    original: Environment[],
  ): any[] {
    const noParentItems = filtered.filter((item) => !(item.idParent > 0));
    const withParentItems = filtered.filter((item) => item.idParent > 0);

    const elaboratedList: any[] = [];

    noParentItems.forEach((item) => {
      elaboratedList.push(item);

      let children = withParentItems.filter(
        (child) => child.idParent === item.id,
      );

      children = this.addParentDescriptionToChildren(children, item);
      elaboratedList.push(...children);
    });

    let remainingItems = withParentItems.filter(
      (item) => !elaboratedList.some((sortedItem) => sortedItem.id === item.id),
    );
    remainingItems = this.addParentDescriptionToRemainingItems(
      remainingItems,
      original,
    );

    elaboratedList.push(...remainingItems);

    return elaboratedList;
  }

  /**
   * Add parent description to children environments
   * @param children
   * @param parent
   * @returns
   */
  private addParentDescriptionToChildren(children: any[], parent: any): any[] {
    return children.map((child) => {
      return {
        ...child,
        descriptionEnvironment: `${parent.descriptionEnvironment} - ${child.descriptionEnvironment}`,
      };
    });
  }

  /**
   * Add parent description to remaining child environments
   * @param remainingItems
   * @returns
   */
  private addParentDescriptionToRemainingItems(
    remainingItems: any[],
    original: Environment[] = this.listEnvironmentsOriginal,
  ): any[] {
    return remainingItems.map((item) => {
      const parent = original.find(
        (parentItem) => parentItem.id === item.idParent,
      );

      return {
        ...item,
        descriptionEnvironment: `${parent?.descriptionEnvironment || ""} - ${item.descriptionEnvironment
          }`,
      };
    });
  }

  /**
   * Sort the environments based on the descriptionEnvironment alphabetically
   * @param sortedList
   */
  private sortByDescription(sortedList: any[]): void {
    sortedList.sort((a, b) => {
      if (a.descriptionEnvironment < b.descriptionEnvironment) {
        return -1;
      }
      if (a.descriptionEnvironment > b.descriptionEnvironment) {
        return 1;
      }
      return 0;
    });
  }

  /**
   * Delete smart component
   * @param idSmartComponent
   */
  public async onClickDeleteAssociationSmartComponent(
    idSmartComponent: number,
  ) {
    try {
      await this._loaderService.presentLoaderWaiting();

      await this._smartComponentService.deleteAssociationSmartComponentEnvironment(
        idSmartComponent,
      );
      await this.refreshEnvironmentAssociated(this.idSmartComponentSelected);
      await this._loaderService.dismissLoaderWaiting();
    } catch {
      await this._loaderService.dismissLoaderWaiting();
      await this._alertService.presentAlertSomethingWrong();
    }
  }

  /**
   * On click open list smart component
   */
  public onClickOpenListSmartComponent(key: string, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.isContentVisible[key] = !this.isContentVisible[key];
  }

  /**
   * On click show config
   * @param event
   */
  public onClickShowConfig(event: Event) {
    event.preventDefault();
    this.showConfigDiv = true;
    this.showAssociationDiv = false;
  }

  /**
   * On click show association
   * @param event
   */
  public onClickShowAssociation(event: Event) {
    event.preventDefault();
    this.showConfigDiv = false;
    this.showAssociationDiv = true;
  }

  /**
   * On click open the popup with the preview of the selected smart component.
   */
  public async onClickOpenPreview(): Promise<void> {
    if (this.dynamicForm.dirty || this.insertNewSmartComponent) {
      const saveBeforePreview =
        await this._alertService.presentAlertConfirmOrDismiss(
          this._translateService.instant("dictionary.attention"),
          "",
          this._translateService.instant("dictionary.previewSaveRequired"),
        );

      if (!saveBeforePreview) {
        return;
      }

      //If confirmed, save the smart component before opening the preview
      const isSaved = await this.onClickSaveSmartComponent(false);

      if (!isSaved) {
        return;
      }
    }

    this.buildPreviewSmartComponent();
    this.isPreviewModalOpen = true;
  }

  /**
   * Close the preview popup and destroy the rendered widget
   */
  public onClosePreviewModal(): void {
    this.isPreviewModalOpen = false;
  }

  /**
   * Build the smart component rendered by the preview. A new instance is created on every call so
   * that the rendering directive re-creates the widget and reloads the saved configuration
   */
  private buildPreviewSmartComponent(
    association: SmartComponentEnvironmentAssociated = this.listEnvironmentAssociated[0],
  ): void {
    const previewSmartComponent: SmartComponent = new SmartComponent();

    previewSmartComponent.id = this.idSmartComponentSelected;
    previewSmartComponent.idSmartComponentKind = this.typeSmartComponentSelected;
    previewSmartComponent.viewMode = association?.viewMode ?? ViewMode.COMPACT;

    //Counter widgets and address functions need an environment to be resolved: by default the first associated one
    this.previewIdEnvironment = association?.idEnvironment ?? null;
    this.previewEnvironmentName = association?.environmentName ?? "";
    this.previewEnvironmentText = this.previewEnvironmentName;
    this.previewSmartComponent = previewSmartComponent;
  }

  /**
   * Address functions are resolved against an environment, so the preview lets the user choose
   * which one to use when at least one of them is selected
   * @returns true when at least one address skill is set with an address function
   */
  public isAddressFunctionSelected(): boolean {
    return this.addressFunctionMappings.length > 0;
  }

  /**
   * The preview environment select is shown only when there is an actual choice to make
   * @returns true when address functions are selected and the smart component is associated to more environments
   */
  public isPreviewEnvironmentSelectable(): boolean {
    return (
      this.isAddressFunctionSelected() && this.listEnvironmentAssociated.length > 1
    );
  }

  /**
   * On focus show every associated environment, since the bar already contains the selected one,
   * and select its text so that typing replaces it
   * @param event focus event of the search bar
   */
  public async onPreviewEnvironmentFocus(event: CustomEvent): Promise<void> {
    this.loadPreviewEnvironmentSuggestions("");

    const inputElement: HTMLInputElement = await (
      event.target as HTMLIonInputElement
    ).getInputElement();
    inputElement.select();
  }

  /**
   * Filter the associated environments with the text typed in the search bar
   * @param event input event of the search bar
   */
  public onPreviewEnvironmentInput(event: CustomEvent): void {
    this.previewEnvironmentText = event.detail.value ?? "";
    this.loadPreviewEnvironmentSuggestions(this.previewEnvironmentText);
  }

  /**
   * Close the suggestions and put back the selected environment, so the bar never stays with a partial text.
   * The delay lets a tap on a suggestion be handled before the list disappears
   */
  public onPreviewEnvironmentBlur(): void {
    setTimeout(() => {
      this.clearPreviewEnvironmentSuggestions();
      this.previewEnvironmentText = this.previewEnvironmentName;
    }, 150);
  }

  /**
   * Navigate the suggestions with the keyboard
   * @param event keyboard event
   */
  public onPreviewEnvironmentKeydown(event: KeyboardEvent): void {
    const suggestionsCount: number = this.listPreviewEnvironmentSuggestions.length;

    if (suggestionsCount === 0) {
      return;
    }

    switch (event.key.toLocaleLowerCase()) {
      case "arrowdown":
        event.preventDefault();
        this.highlightedPreviewEnvironmentIndex =
          (this.highlightedPreviewEnvironmentIndex + 1) % suggestionsCount;
        break;
      case "arrowup":
        event.preventDefault();
        this.highlightedPreviewEnvironmentIndex =
          this.highlightedPreviewEnvironmentIndex <= 0
            ? suggestionsCount - 1
            : this.highlightedPreviewEnvironmentIndex - 1;
        break;
      case "enter":
        event.preventDefault();
        this.onSelectPreviewEnvironment(
          this.listPreviewEnvironmentSuggestions[
            Math.max(this.highlightedPreviewEnvironmentIndex, 0)
          ],
        );
        break;
      case "escape":
        //Closes only the suggestions, not the preview modal
        event.stopPropagation();
        this.clearPreviewEnvironmentSuggestions();
        break;
    }
  }

  /**
   * Use the chosen associated environment for the preview
   * @param association the chosen association
   */
  public onSelectPreviewEnvironment(
    association: SmartComponentEnvironmentAssociated,
  ): void {
    this.clearPreviewEnvironmentSuggestions();
    (document.activeElement as HTMLElement)?.blur();

    if (association.idEnvironment === this.previewIdEnvironment) {
      this.previewEnvironmentText = this.previewEnvironmentName;
      return;
    }

    //Rebuilt so that the widget is re-created with the view mode of the chosen association too
    this.buildPreviewSmartComponent(association);
  }

  /**
   * Load the associated environments whose name contains the text searched
   * @param textSearched text typed in the search bar
   */
  private loadPreviewEnvironmentSuggestions(textSearched: string): void {
    const normalizedTextSearched: string = textSearched.trim().toLowerCase();

    this.highlightedPreviewEnvironmentIndex = -1;
    this.listPreviewEnvironmentSuggestions = this.listEnvironmentAssociated.filter(
      (item: SmartComponentEnvironmentAssociated) =>
        item.environmentName?.toLowerCase().includes(normalizedTextSearched),
    );
  }

  /**
   * Close the preview environment suggestions
   */
  private clearPreviewEnvironmentSuggestions(): void {
    this.listPreviewEnvironmentSuggestions = [];
    this.highlightedPreviewEnvironmentIndex = -1;
  }

  /**
   * On click save smart component
   * @param showSuccessMessage false to save without confirming it with a popup
   * @returns true when the smart component has been saved, false otherwise
   */
  public async onClickSaveSmartComponent(
    showSuccessMessage: boolean = true,
  ): Promise<boolean> {
    const missingRequired = this.getMissingRequiredSkills();
    if (
      this.dynamicForm.valid &&
      this.checkMandatorySkillsEletricCounter() &&
      missingRequired.length === 0
    ) {
      if (!this.insertNewSmartComponent) {
        return await this.updateSmartComponent(showSuccessMessage);
      } else {
        return await this.saveNewSmartComponent(showSuccessMessage);
      }
    } else {
      await this._alertService.presentAlertOk(
        "",
        this._translateService.instant("dictionary.formFillErrors"),
        this.getErrorMessageToShow(missingRequired),
      );
      return false;
    }
  }

  /**
   * Return descriptions of required skills that don't have a value in the form
   */
  private getMissingRequiredSkills(): string[] {
    if (!this.fields) {
      return [];
    }
    return this.fields
      .filter((field) => field.isRequired)
      .filter((field) => {
        const value = this.dynamicForm.get(field.titleSkill)?.value;
        return value === null || value === undefined || value === "";
      })
      .map((field) => this.getDescriptionSkill(field.titleSkill));
  }

  /**
   * Check if an input will be rendered on the page
   * @param field
   * @returns true if conditions are satisfied, so the input will be rendered on the page
   */
  public isInputRendered(field: SmartComponentPropertyDetails): boolean {
    if (this.typeSmartComponentSelected === SmartComponentType.ELECTRIC) {
      if (
        this.isDigitalPlace &&
        this._themeService.applicationTheme === ApplicationTheme.DIGITAL_PLACE
      ) {
        return (
          field.dataFormat === SkillFormat.TEXT ||
          field.titleSkill === "ElectricEnergyProduced" ||
          field.titleSkill === "ElectricEnergyAbsorbed" ||
          field.titleSkill === "ElectricPowerExchange"
        );
      }
    } else if (this.typeSmartComponentSelected === SmartComponentType.LABEL) {
      return (
        field.titleSkill !== "LabelButtonFormatting" &&
        field.titleSkill !== "LabelButtonOrientation" &&
        field.titleSkill !== "LabelButtonIconsState" &&
        field.titleSkill !== "LabelButtonDefaultImage"
      );
    }
    return true;
  }

  /**
   * Get the error message to show if there are errors in fields
   * @returns string of the message
   */
  private getErrorMessageToShow(missingRequired: string[] = []): string {
    let errorMessage: Array<string> = [];

    if (!this.dynamicForm.valid || missingRequired.length > 0) {
      const base = this._translateService.instant("dictionary.mandatoryFieldsMissing");
      errorMessage.push(
        missingRequired.length > 0
          ? `${base}: ${missingRequired.join(", ")}`
          : base,
      );
    }

    if (this.typeSmartComponentSelected === SmartComponentType.LABEL) {
      if (
        this.dynamicForm.get(["LabelButtonFormatting", "NValue"])?.errors
          ?.isNumeric === false
      ) {
        errorMessage.push(this._translateService.instant("dictionary.numericValueRequiredValueOfN"));
      }

      if (
        this.dynamicForm.get(["LabelButtonFormatting", "additionalKeyword"])
          ?.errors?.hashtags === true
      ) {
        errorMessage.push(this._translateService.instant("dictionary.errorFieldHashtagKeyword"));
      }

      //When label buttonIconsState has only one field get its name in order to search if there are any errors
      const labelButtonIconsStateControlName = Object.keys(
        this.dynamicForm.controls["LabelButtonIconsState"]["controls"],
      )[0];

      if (
        labelButtonIconsStateControlName &&
        this.dynamicForm.get([
          "LabelButtonIconsState",
          labelButtonIconsStateControlName,
        ]).errors?.booleanValue === false
      ) {
        errorMessage.push(this._translateService.instant("dictionary.booleanValueRequired"));
      }

      if (
        labelButtonIconsStateControlName &&
        this.dynamicForm.get([
          "LabelButtonIconsState",
          labelButtonIconsStateControlName,
        ]).errors?.isNumeric === false
      ) {
        errorMessage.push(this._translateService.instant("dictionary.numericValueRequiredState"));
      }

      if (
        labelButtonIconsStateControlName &&
        this.dynamicForm.get([
          "LabelButtonIconsState",
          labelButtonIconsStateControlName,
        ]).errors?.hashtags === true
      ) {
        errorMessage.push(this._translateService.instant("dictionary.errorFieldHashtagState"));
      }
    }

    if (!this.checkMandatorySkillsEletricCounter()) {
      errorMessage.push(this._translateService.instant("dictionary.electricFieldMissing"));
    }

    return errorMessage.join(`<br /><br />`);
  }

  /**
   * Check if the electric meter has at least one skill selected
   * @returns
   */
  private checkMandatorySkillsEletricCounter() {
    if (this.typeSmartComponentSelected == SmartComponentType.ELECTRIC) {
      const absorbed =
        this.dynamicForm.controls[
          SkillNameList.COUNTER_ELECTRIC_ENERGY_ABSORBED
        ]?.value;
      const produced =
        this.dynamicForm.controls[
          SkillNameList.COUNTER_ELECTRIC_ENERGY_PRODUCED
        ]?.value;

      if (absorbed || produced) {
        return true;
      }

      return false;
    } else {
      return true;
    }
  }

  /**
   * Update smart component
   * @param showSuccessMessage false to save without confirming it with a popup
   * @returns true when the update succeeded, false otherwise
   */
  private async updateSmartComponent(
    showSuccessMessage: boolean = true,
  ): Promise<boolean> {
    try {
      await this._loaderService.presentLoaderWaiting();
      this.listPropertiesSave.skills = [];

      const formData = this.dynamicForm.value;
      this.listPropertiesSave.id = this.listProperties.id;
      this.listPropertiesSave.idSmartComponentKind =
        this.listProperties.idSmartComponentKind;

      this.listPropertiesSave.skills = this.listProperties.skills.map(
        (field) => {
          let value;
          let addressFunction = false;

          if (field.dataFormat === SkillFormat.ADDRESS) {
            const addressField = this.addressFieldMappings.find(
              (item) => item.titleSkill === field.titleSkill,
            );

            value = addressField?.id;
            if (!addressField) {
              const addressFunctionField = this.addressFunctionMappings.find(
                (item) => item.titleSkill === field.titleSkill,
              );

              value = addressFunctionField?.id;
              if (addressFunctionField) {
                addressFunction = true;
              }
            }
          } else if (field.dataFormat === SkillFormat.SCENARIO) {
            // Save the scenario id (kept in the mapping), not the displayed name
            value = this.scenarioFieldMappings.find(
              (item) => item.titleSkill === field.titleSkill,
            )?.id;
          } else {
            if (field.titleSkill === "LabelButtonFormatting") {
              if (!this.isReversed) {
                value =
                  (formData["LabelButtonFormatting"].NValue
                    ? formData["LabelButtonFormatting"].selectedKeyword.replace(
                      "N",
                      formData[
                        "LabelButtonFormatting"
                      ].NValue.toString().trim(),
                    )
                    : formData["LabelButtonFormatting"].selectedKeyword) +
                  " " +
                  formData["LabelButtonFormatting"].additionalKeyword.trim();
              } else {
                value =
                  formData["LabelButtonFormatting"].additionalKeyword.trim() +
                  " " +
                  (formData["LabelButtonFormatting"].NValue
                    ? formData["LabelButtonFormatting"].selectedKeyword.replace(
                      "N",
                      formData[
                        "LabelButtonFormatting"
                      ].NValue.toString().trim(),
                    )
                    : formData["LabelButtonFormatting"].selectedKeyword);
              }
            } else if (field.titleSkill === "LabelButtonIconsState") {
              //When saving replace the string starting with # with the new value
              if (this.oneIconStateField) {
                const stringWithValue = this._labelButtonIconsState[0].replace(
                  /((=).+|=)/,
                  `=${this.dynamicForm.value.LabelButtonIconsState[this.iconsStateFields[0]]?.trim()}#`,
                );
                this._labelButtonIconsState = [
                  stringWithValue.replace(
                    /((#).+|#)/,
                    `#${this.dynamicForm.value.LabelButtonIconsState.icon?.trim()}`,
                  ),
                ];
              } else {
                this._labelButtonIconsState = this._labelButtonIconsState.map(
                  (item) => {
                    let newString = "";
                    Object.keys(
                      this.dynamicForm.value.LabelButtonIconsState,
                    ).forEach((key) => {
                      if (item.startsWith(key)) {
                        return (newString = item.replace(
                          /((#).+|#)/,
                          `#${this.dynamicForm.value.LabelButtonIconsState[
                            key
                          ]?.trim()}`,
                        ));
                      }
                    });
                    return newString;
                  },
                );
              }
              value = this._labelButtonIconsState.join("|");
            } else {
              value = formData[field?.titleSkill];
            }
          }

          if (value == undefined) {
            value = "";
          }
          return {
            idSmartComponentSkill: field.idSmartComponentSkill,
            id: field.id,
            dataFormat: field.dataFormat,
            value: value?.toString(),
            isAddressFunction: addressFunction,
          };
        },
      );

      await this._smartComponentService.saveChangesSkills(
        this.listPropertiesSave,
      );

      //The form now matches the saved configuration, so the preview can be shown without warnings
      this.dynamicForm.markAsPristine();

      this.reloadSmartComponent.emit(this.idArea);
      await this._loaderService.dismissLoaderWaiting();

      if (showSuccessMessage) {
        await this._alertService.presentAlertOk(this._translateService.instant("dictionary.saveSuccess"), "", "");
      }
      return true;
    } catch {
      await this._loaderService.dismissLoaderWaiting();
      await this._alertService.presentAlertSomethingWrong();
      return false;
    }
  }

  /**
   * Save new smart components
   * @param showSuccessMessage false to save without confirming it with a popup
   * @returns true when the new smart component has been created, false otherwise
   */
  private async saveNewSmartComponent(
    showSuccessMessage: boolean = true,
  ): Promise<boolean> {
    try {
      await this._loaderService.presentLoaderWaiting();
      this.listPropertiesNewSave.skills = [];

      const formData = this.dynamicForm.value;
      this.listPropertiesNewSave.idArea = this.idArea;
      this.listPropertiesNewSave.idSmartComponentKind =
        this.listSkillNewComponent[0].idSmartComponentKind;

      //Initialise Skills' value with associated forms' value
      this.listPropertiesNewSave.skills = this.listSkillNewComponent.map(
        (field) => {
          let value;
          let isAddressFunction = false;
          if (field.dataFormat === SkillFormat.ADDRESS) {
            const addressField = this.addressFieldMappings.find(
              (item) => item.titleSkill === field.titleSkill,
            );
            value = addressField?.id;
            if (!addressField) {
              const addressFunctionField = this.addressFunctionMappings.find(
                (item) => item.titleSkill === field.titleSkill,
              );
              value = addressFunctionField?.id;
              if (addressFunctionField) {
                isAddressFunction = true;
              }
            }
          } else if (field.dataFormat === SkillFormat.SCENARIO) {
            // Save the scenario id (kept in the mapping), not the displayed name
            value = this.scenarioFieldMappings.find(
              (item) => item.titleSkill === field.titleSkill,
            )?.id;
          } else {
            if (field.titleSkill === "LabelButtonFormatting") {
              if (!this.isReversed) {
                value =
                  (formData["LabelButtonFormatting"].NValue
                    ? formData["LabelButtonFormatting"].selectedKeyword.replace(
                      "N",
                      formData[
                        "LabelButtonFormatting"
                      ].NValue.toString().trim(),
                    )
                    : formData["LabelButtonFormatting"].selectedKeyword) +
                  " " +
                  formData["LabelButtonFormatting"].additionalKeyword.trim();
              } else {
                value =
                  formData["LabelButtonFormatting"].additionalKeyword.trim() +
                  " " +
                  (formData["LabelButtonFormatting"].NValue
                    ? formData["LabelButtonFormatting"].selectedKeyword.replace(
                      "N",
                      formData[
                        "LabelButtonFormatting"
                      ].NValue.toString().trim(),
                    )
                    : formData["LabelButtonFormatting"].selectedKeyword);
              }
            } else if (field.titleSkill === "LabelButtonIconsState") {
              //When saving replace the string starting with # with the new value
              this._labelButtonIconsState = this._labelButtonIconsState.map(
                (item) => {
                  let newString = "";
                  Object.keys(
                    this.dynamicForm.value.LabelButtonIconsState,
                  ).forEach((key) => {
                    if (item.startsWith(key)) {
                      if (this.oneIconStateField) {
                        const stringWithValue = item.replace(
                          /{value}/,
                          this.dynamicForm.value.LabelButtonIconsState[
                            key
                          ]?.trim(),
                        );
                        return (newString = stringWithValue.replace(
                          /#/,
                          `#${this.dynamicForm.value.LabelButtonIconsState.icon?.trim()}`,
                        ));
                      }
                      return (newString = item.replace(
                        /#/,
                        `#${this.dynamicForm.value.LabelButtonIconsState[
                          key
                        ]?.trim()}`,
                      ));
                    }
                  });
                  return newString;
                },
              );
              value = this._labelButtonIconsState.join("|");
            } else {
              value = formData[field?.titleSkill];
            }
          }

          //If value is undefined/null but there's a default value use it
          if (value === undefined || value === null) {
            if (field.default) {
              value = field.default;
            } else {
              value = "";
            }
          } else {
            value = value.toString();
          }

          return {
            idSmartComponentSkill: field.id,
            dataFormat: field.dataFormat,
            value: value,
            isAddressFunction: isAddressFunction,
          };
        },
      );
      let smartComponentCreated =
        await this._smartComponentService.saveNewSmartComponents(
          this.listPropertiesNewSave,
        );

      this.idSmartComponentSelected = smartComponentCreated.id;

      //Associating the smart component to the first environment
      const smartComponentToAssociate: AssociationSmartComponent = {
        idSmartComponent: smartComponentCreated.id,
        idEnvironment: this.listEnvironmentsOriginal[0].id,
      };
      await this._smartComponentService.addAssociateSmartComponentEnvironment([
        smartComponentToAssociate,
      ]);

      this.reloadSmartComponent.emit(this.idArea);

      await this.onClickViewSmartComponent(smartComponentCreated.id);

      if (showSuccessMessage) {
        await this._alertService.presentAlertOk(this._translateService.instant("dictionary.saveSuccess"), "", "");
      }
      return true;
    } catch {
      await this._loaderService.dismissLoaderWaiting();
      await this._alertService.presentAlertSomethingWrong();
      return false;
    }
  }

  /**
   * On click add smart component
   */
  public async onClickAddSmartComponent(): Promise<void> {
    if (this.listEnvironmentsOriginal.length > 0) {
      const modal = await this._modalCtrl.create({
        component: AddSmartComponentComponent,
      });

      modal.present();

      const result = await modal.onDidDismiss();

      this.insertNewSmartComponent = true;
      this.idSmartComponentSelected = 0;

      if (result.data.action != "cancel" && result.role != "backdrop") {
        try {
          this.showError = false;

          // Reset value in search address skill component when adding a new smart component
          this._smartComponentService.searchAdressesFieldsValue.next({
            name: "",
            address: "",
          });

          this.showConfigDiv = true;
          this.showAssociationDiv = false;
          this.isPreviewModalOpen = false;
          await this._loaderService.presentLoaderWaiting();
          if (result.data?.action) {
            this.addressFieldMappings = [];
            await this.getTemplateNewSmartComponent(result.data?.action);
            this.typeSmartComponentSelected = result.data?.action;
          } else {
            this._alertService.presentAlertSomethingWrong();
          }
        } catch {
          await this._loaderService.dismissLoaderWaiting();

          // show error when skills are not loaded
          this.showError = true;
        } finally {
          await this._loaderService.dismissLoaderWaiting();
        }
      }
    } else {
      this._alertService.showAlertError(
        this._translateService.instant(
          this.isDigitalPlace ? "dictionary.cannotAddNewSmartComponent" : "dictionary.cannotAddNewSmartComponentGeneric"
        )
      );
    }
  }

  /**
   * Create new smart component
   * @param idType
   */
  public async getTemplateNewSmartComponent(idType: number) {
    this.listSkillNewComponent =
      await this._smartComponentService.getTemplateSmartComponent(idType);

    this.reloadForm();
    this.isReversed = false;
    this.hideMainTab = false;
  }

  /**
   * Show view mode selection if the selected component is a counter or a thermostat
   */
  public isViewModeSelectionVisible(): boolean {
    return (
      this.typeSmartComponentSelected !== SmartComponentType.LIGHT &&
      this.typeSmartComponentSelected !== SmartComponentType.DIMMER &&
      this.typeSmartComponentSelected !== SmartComponentType.ALARM &&
      this.typeSmartComponentSelected !== SmartComponentType.CONTACT &&
      this.typeSmartComponentSelected !== SmartComponentType.UNKNOWN &&
      this.typeSmartComponentSelected !== SmartComponentType.WEATHER_STATION &&
      this.typeSmartComponentSelected !== SmartComponentType.LABEL &&
      this.typeSmartComponentSelected !== SmartComponentType.SCENARIO &&
      this.typeSmartComponentSelected !== SmartComponentType.PAGE_BREAK
    );
  }

  /**
   * After selected an option and confirmed the selection call API to update viewMode
   * @param event
   * @param idEnvironment
   */
  public async onIonChangeUpdateViewMode(
    event: Event,
    idEnvironment: number,
  ): Promise<void> {
    const selectedOption =
      (event as CustomEvent).detail.value === "expanded"
        ? ViewMode.EXPANDED
        : ViewMode.COMPACT;

    await this._smartComponentService.updateViewMode(
      this.idSmartComponentSelected,
      idEnvironment,
      selectedOption,
    );
  }

  /**
   * Open popup for selecting environment
   */
  public async onClickOpenModalSelectEnvironment(): Promise<void> {
    let selectedItem: { name: string; value: number };

    if (this.selectedEnvName && this.selectedEnvId) {
      selectedItem = { name: this.selectedEnvName, value: this.selectedEnvId };
    }

    const modal = await this._modalCtrl.create({
      component: PopupSearchSelectComponent,
      componentProps: {
        searchBarPlaceholder: this._translateService.instant("dictionary.searchEnvironment"),
        selectedItem: selectedItem,
        items: this.listEnvironments.map((item: Environment) => {
          return {
            name: item.descriptionEnvironment,
            value: item.id,
          };
        }),
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data) {
      this.selectedEnvId = data.selectedValue;
      this.selectedEnvName = data.selectedName;
    }
  }

  /**
   * Open the searchable popup used to filter the smart component list by environment.
   */
  public async onClickOpenEnvironmentFilter(): Promise<void> {
    const allEnvironmentsItem = { name: this._translateService.instant("dictionary.allEnvironments"), value: 0 };

    const modal = await this._modalCtrl.create({
      component: PopupSearchSelectComponent,
      componentProps: {
        searchBarPlaceholder: this._translateService.instant("dictionary.searchEnvironment"),
        selectedItem: this.idEnvironmentFilter
          ? { name: this.environmentFilterName, value: this.idEnvironmentFilter }
          : allEnvironmentsItem,
        items: [
          allEnvironmentsItem,
          ...this.getEnvironmentFilterOptions().map((item: Environment) => ({
            name: item.descriptionEnvironment,
            value: item.id,
          })),
        ],
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data && (data.selectedValue || null) !== this.idEnvironmentFilter) {
      this.environmentFilterChange.emit(data.selectedValue || null);
    }
  }

  /**
   * Remove the environment filter and show again the smart components of every environment
   * @param event click event
   */
  public onClickClearEnvironmentFilter(event?: Event): void {
    event?.stopPropagation();
    this.environmentFilterChange.emit(null);
  }

  /**
   * Environments selectable in the filter
   * @returns elaborated list of environments
   */
  private getEnvironmentFilterOptions(): Environment[] {
    const listEnvironments: Environment[] = this.listEnvironmentsOriginal ?? [];
    const filtered: Environment[] = this.isDigitalPlace
      ? listEnvironments.filter(
        (item: Environment) =>
          item.category === EnvironmentCategory.APARTAMENT ||
          item.category === EnvironmentCategory.ROOM,
      )
      : listEnvironments;

    return this.buildElaboratedEnvironmentList(filtered, listEnvironments);
  }

  /**
   * Open popup for selecting scenario
   * @returns Promise<void>
   */
  public async onClickOpenPopupScenarios(): Promise<void> {

    await this._loaderService.presentLoaderWaiting();

    const scenarioField = (this.fields || []).find(
      (field) => field.dataFormat === SkillFormat.SCENARIO,
    );

    if (!scenarioField) {
      await this._loaderService.dismissLoaderWaiting();
      return;
    }

    // The current selection id is kept in the mapping (the control holds the name)
    const currentMapping = this.scenarioFieldMappings.find(
      (item) => item.titleSkill === scenarioField.titleSkill,
    );
    const currentScenario = currentMapping
      ? this._listScenario.find(
        (scenario: Scenario) => scenario.id === currentMapping.id,
      )
      : null;

    const modal = await this._modalCtrl.create({
      component: PopupSearchSelectComponent,
      componentProps: {
        searchBarPlaceholder: this._translateService.instant("dictionary.searchScenario"),
        selectedItem: currentScenario
          ? { name: currentScenario.name, value: currentScenario.id }
          : null,
        items: this._listScenario.map((scenario: Scenario) => {
          return {
            name: scenario.name,
            value: scenario.id,
          };
        }),
      },
    });

    await modal.present();
    await this._loaderService.dismissLoaderWaiting();

    const { data } = await modal.onDidDismiss();

    if (data) {
      // The form control holds the name (display); the id is kept in the mapping for saving
      this.dynamicForm
        .get(scenarioField.titleSkill)
        .setValue(data.selectedName);
      this.setScenarioFieldMapping(scenarioField.titleSkill, data.selectedValue);
      this.dynamicForm.markAsDirty();
    }
  }

  /**
   * Open popup with searchable list of environments for the PageBreakIDEnvironment skill
   */
  public async onClickOpenModalSelectPageBreakEnvironment(
    field: any,
  ): Promise<void> {
    const currentId = Number(this.dynamicForm.get(field.titleSkill)?.value);
    let selectedItem: { name: string; value: number };

    if (currentId) {
      const currentEnv = this.pageBreakEnvironmentList.find(
        (e: any) => Number(e.id) === currentId,
      );
      if (currentEnv) {
        selectedItem = {
          name: currentEnv.descriptionEnvironment,
          value: currentEnv.id,
        };
      }
    }

    const modal = await this._modalCtrl.create({
      component: PopupSearchSelectComponent,
      componentProps: {
        searchBarPlaceholder: this._translateService.instant("dictionary.searchEnvironment"),
        selectedItem: selectedItem,
        items: this.pageBreakEnvironmentList.map((item: any) => ({
          name: item.descriptionEnvironment,
          value: item.id,
        })),
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data) {
      this.dynamicForm.get(field.titleSkill)?.setValue(data.selectedValue);
      this.dynamicForm.markAsDirty();
      this.refreshPageBreakEnvironmentName();
    }
  }

  /**
   * Upsert the scenario id associated to a scenario skill.
   * @param titleSkill the scenario skill name
   * @param id the selected scenario id
   */
  private setScenarioFieldMapping(titleSkill: string, id: number): void {
    const existingIndex = this.scenarioFieldMappings.findIndex(
      (item) => item.titleSkill === titleSkill,
    );

    if (existingIndex !== -1) {
      this.scenarioFieldMappings[existingIndex].id = id;
    } else {
      this.scenarioFieldMappings.push({ titleSkill, id });
    }
  }

  /**
   * Refresh the display name shown for every scenario skill, resolving the id
   * kept in the mapping against the (updated) scenario list.
   */
  private refreshScenarioDisplayNames(): void {
    this.scenarioFieldMappings.forEach((mapping) => {
      const scenario = this._listScenario.find(
        (item: Scenario) => item.id === mapping.id,
      );

      if (scenario) {
        this.dynamicForm
          .get(mapping.titleSkill)
          ?.setValue(scenario.name, { emitEvent: false });
      }
    });
  }


  /**
   * Recompute the displayed name for the selected PageBreak environment, based on the
   * id stored in the form control and the loaded pageBreakEnvironmentList
   */
  private refreshPageBreakEnvironmentName(): void {
    const id = Number(
      this.dynamicForm.get(SkillNameList.PAGE_BREAK_ID_ENVIRONMENT)?.value,
    );
    if (!id) {
      this.pageBreakEnvironmentName = "";
      return;
    }
    const env = this.pageBreakEnvironmentList.find(
      (e: any) => Number(e.id) === id,
    );
    this.pageBreakEnvironmentName = env ? env.descriptionEnvironment : "";
  }

  /**
   * Get boolean in order to show note about dataprocess (only for BIGStudio)
   * @param skill name of the skill
   * @returns true if it's BIGStudio and skill is relative to counter, false otherwise
   */
  public showNoteDataprocess(skill: string): boolean {
    return (
      !this.isDigitalPlace &&
      (skill === SkillNameList.COUNTER_DISTRIBUTOR_CONSUMPTION ||
        skill === SkillNameList.COUNTER_GAS_VOLUME ||
        skill === SkillNameList.COUNTER_COLDWATER_VOLUME ||
        skill === SkillNameList.COUNTER_HOTWATER_VOLUME ||
        skill === SkillNameList.COUNTER_HEATING_ENERGY_HEAT ||
        skill === SkillNameList.COUNTER_HEATING_VOLUME ||
        skill === SkillNameList.COUNTER_ELECTRIC_ENERGY_ABSORBED ||
        skill === SkillNameList.COUNTER_ELECTRIC_ENERGY_PRODUCED ||
        skill === SkillNameList.COUNTER_ELECTRIC_POWER_EXCHANGE ||
        skill ===
        SkillNameList.COUNTER_ELECTRIC_ACTIVE_ENERGY_IMPORTED_PREVIOUS_DAY_F1 ||
        skill ===
        SkillNameList.COUNTER_ELECTRIC_ACTIVE_ENERGY_IMPORTED_PREVIOUS_DAY_F2 ||
        skill ===
        SkillNameList.COUNTER_ELECTRIC_ACTIVE_ENERGY_IMPORTED_PREVIOUS_DAY_F3 ||
        skill ===
        SkillNameList.COUNTER_ELECTRIC_ACTIVE_ENERGY_IMPORTED_PREVIOUS_DAY_F4 ||
        skill ===
        SkillNameList.COUNTER_ELECTRIC_ACTIVE_ENERGY_IMPORTED_PREVIOUS_DAY_F5 ||
        skill ===
        SkillNameList.COUNTER_ELECTRIC_ACTIVE_ENERGY_IMPORTED_PREVIOUS_DAY_F6)
    );
  }

  /**
   * Check when form changes in order to show/hide label button icon state section
   * @returns form subscription
   */
  private checkForFormChanges(): Subscription {
    return this.dynamicForm.valueChanges.subscribe(async (form) => {
      if (this.typeSmartComponentSelected === SmartComponentType.LABEL) {
        if (
          form.LabelButtonAddressState !== "" &&
          this._idDeviceKind &&
          this._idDeviceKind !== -1 &&
          !this.isLabelButtonIconsStateVisible
        ) {
          try {
            await this._loaderService.presentLoaderWaiting();
            //Get device kind list if it's null
            if (!this._deviceKindList) {
              this._deviceKindList =
                await this._smartComponentService.getAllDeviceKind();
            }
            //Get the specific device kind and the fields to render
            const deviceKind = this._deviceKindList.filter(
              (item: any) => item.id === this._idDeviceKind,
            );
            const fieldsString: string = this.getIconsStateFieldsTranslation(
              deviceKind[0],
            );

            let fields = fieldsString.split("|");

            if (fields.length === 1 && !fields[0].includes("=")) {
              //Concat # to field (used when saving data)
              this._labelButtonIconsState = fields.map((item) =>
                item.concat("={value}#"),
              );
              (
                this.dynamicForm.get(
                  "LabelButtonIconsState",
                ) as UntypedFormGroup
              ).addControl(fields[0], new UntypedFormControl(""), {
                emitEvent: false,
              });
              (
                this.dynamicForm.get(
                  "LabelButtonIconsState",
                ) as UntypedFormGroup
              ).addControl("icon", new UntypedFormControl(""), {
                emitEvent: false,
              });

              //If it's only one field add specific validators and input type
              this.addTypeAndValidatorsToIconsState(
                fields[0],
                deviceKind[0]["gatewayDataFormat"],
              );
              this.oneIconStateField = true;
            } else {
              //Concat # to fields (used when saving data)
              this._labelButtonIconsState = fields
                .filter((item) => item.includes("="))
                .map((item) => item.concat("#"));

              //Exclude fields without = and get fields label
              fields = fields
                .filter((item) => item.includes("="))
                .map((item) => item.split("=")[0]);

              for (let field of fields) {
                (
                  this.dynamicForm.get(
                    "LabelButtonIconsState",
                  ) as UntypedFormGroup
                ).addControl(field, new UntypedFormControl(""), {
                  emitEvent: false,
                });
              }
              this.oneIconStateField = false;
            }
            this.iconsStateFields = fields;
            this.isLabelButtonIconsStateVisible = true;
            await this._loaderService.dismissLoaderWaiting();
          } catch {
            await this._loaderService.dismissLoaderWaiting();
            await this._alertService.presentAlertSomethingWrong();
          }
        } else if (
          form.LabelButtonAddressState === "" &&
          this.dynamicForm.controls["LabelButtonIconsState"]
        ) {
          Object.keys(
            this.dynamicForm.controls["LabelButtonIconsState"]["controls"],
          ).forEach((control) => {
            (
              this.dynamicForm.get("LabelButtonIconsState") as UntypedFormGroup
            ).removeControl(control, { emitEvent: false });
          });
          this.iconsStateFields = [];
          this.isLabelButtonIconsStateVisible = false;
        }
      }
      return;
    });
  }

  /**
   * Get the translation for the fields of icons state
   * @param deviceKind object for device kind
   * @returns translation
   */
  private getIconsStateFieldsTranslation(deviceKind: Object): string {
    switch (this._translateService.getCurrentLang()) {
      case "en":
        return deviceKind["states1033"];
      case "fr":
        return deviceKind["states1036"];
      case "es":
        return deviceKind["states1034"];
      case "de":
        return deviceKind["states1031"];
      default:
        return deviceKind["states"];
    }
  }

  /**
   * When icons state has only one field add type and validators to it
   * @param inputName name of the input
   * @param dataFormat data format of deviceKind
   */
  private addTypeAndValidatorsToIconsState(
    inputName: string,
    dataFormat: string,
  ): void {
    switch (dataFormat) {
      case "Integer":
        this.iconsStateFieldType = "number";
        this.dynamicForm
          .get(["LabelButtonIconsState", inputName])
          .addValidators(this.checkIfValueIsNumeric());
        this.dynamicForm
          .get(["LabelButtonIconsState", inputName])
          .updateValueAndValidity();
        break;
      case "Boolean":
        this.iconsStateFieldType = "number";
        this.dynamicForm
          .get(["LabelButtonIconsState", inputName])
          .addValidators([this.checkIfValueIsBoolean()]);
        this.dynamicForm
          .get(["LabelButtonIconsState", inputName])
          .updateValueAndValidity();
        break;
      default:
        this.iconsStateFieldType = "text";
        this.dynamicForm
          .get(["LabelButtonIconsState", inputName])
          .addValidators(this.checkIfThereAreHashtags());
        this.dynamicForm
          .get(["LabelButtonIconsState", inputName])
          .updateValueAndValidity();
        break;
    }
  }

  /**
   * Validator for keyword field
   * @returns
   */
  private checkIfThereAreHashtags(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value && control.value.match(new RegExp(/#/, "g"))) {
        return { hashtags: true };
      } else {
        return null;
      }
    };
  }

  /**
   * Validator for icons state field if it's boolean
   * @returns
   */
  private checkIfValueIsBoolean(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (parseInt(control.value) === 1 || parseInt(control.value) === 0) {
        return null;
      } else {
        return { booleanValue: false };
      }
    };
  }

  /**
   * Validator for icons state field if input is numeric
   * @returns
   */
  private checkIfValueIsNumeric(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value && control.value.toString().match(/^\d+$/)) {
        return null;
      } else {
        return { isNumeric: false };
      }
    };
  }

  /**
   * Update environments list according to hide data mode
   */
  private showCorrectEnvironmentsList(): Subscription {
    return this._hideDataService.isDataHidden.subscribe((value) => {
      if (value) {
        this.listEnvironments =
          this._hideDataService.hideEnvironmentsElaboratedData();
        this.listEnvironmentAssociated =
          this._hideDataService.hideAssociatedEnvironmentsElaboratedData();
      } else {
        this.listEnvironments = this._hideDataService.envOriginalData.value;
        this.listEnvironmentAssociated =
          this._hideDataService.envAssociatedOriginalData.value;
      }
    });
  }

  /**
   * Hide the currently selected smart component and clear the list filters
   * (search term and component-type dropdown), keeping the UI and the filtered
   * list in sync
   */
  private resetSelectionAndFilters(): void {
    this.hideMainTab = true;
    this.isPreviewModalOpen = false;
    this.idSmartComponentSelected = 0;
    this.searchTerm = "";
    this.selectedValue = null;
    this._selectKind = 0;
  }

}
